import * as Sentry from '@sentry/react';
import React, { useCallback, useEffect, useLayoutEffect, useMemo, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate } from "react-router-dom";
import { useReactToPrint } from 'react-to-print';
import { ArrowBack, Bookmark, Delete, Fullscreen, FullscreenExit, KeyboardArrowDown, MenuBook, MenuOutlined, ChevronLeft, ChevronRight } from '@mui/icons-material';
import { Button, Checkbox, Drawer, FormControlLabel, IconButton, Modal, Alert } from '@mui/material';
import AnswerPopup from 'components/AnswerPopup';
import PDFPopup from 'components/PDFPopup';
import ActivityStandardsPopup from 'components/ActivityStandardsPopup';
import AssignableNotificationAnswer from 'components/AssignableNotificationAnswer';
import AssignmentAiSection from 'components/AssignmentAiGenerate/AssignmentAiModal';
import COLOR from 'utils/constants/color';
import ClickOutside from 'components/OnClickOutside';
import CreateStoryModal from 'components/StoryWithAi/CreateStoryModal';
import Differentiation from 'components/Differentiation/Differentiation';
import DifferentiationViewModal from 'components/Differentiation/DifferentiationViewModal';
import EbookGallleryView, { ViewGallery } from 'components/EbookGallleryView';
import EbookTooling from 'features/EbookTooling';
import ImageHighlighter from 'components/ImageHighlighter';
import Instructions from "modules/instructions/teacher/Instructions";
import LessonViewModal from 'components/SuperLesson/LessonViewModal';
import Loading from 'components/Loading';
import MainbookPopup from 'components/MainbookPopup';
import SentenceStarterBookPopUp from 'modules/sentenceStarter/teacher/sentenceStarterBookPopUp';
import SentenceStarterPopUp from 'modules/sentenceStarter/teacher';
import ShowBookPreviewExtensionActivity from 'modules/extraResource/teacher/showBookPreviewExtensionActivity';
import {Snackbar } from '@mui/material';
import StoryAIPopup from 'components/StoryAIPopup';
import StoryViewModal from 'components/StoryWithAi/StoryViewModal';
import SuperLessons from 'components/SuperLesson/SuperLesson';
import TwoSidePages from 'components/TwoSideView/TwoSidePages';
import ViewArticleLevels from 'components/ebook/levels/LevelModal';
import Vocabilary from "modules/word_bank/teacher/vocab/Vocabilary";
import VocabilaryForNonSpanish from 'modules/word_bank/teacher/vocab/VocabilaryNonSpanish';
import moment from 'moment';
import styled from 'styled-components';
import useOrientationFullScreen from 'components/hooks/useOrientationFullScreen';
import { CloseCircleFilled, FundOutlined, LeftCircleOutlined, RightCircleOutlined } from '@ant-design/icons';
import { Col, Row, Tooltip } from 'antd';
import { useAlert } from 'components/UI/alertSakeBar/alertProvider';
import { Dropdown } from 'antd';
import { addPrintableClass, checkStandardExam, removePrintableClass } from 'utils/methods/textMethod';
import { debounce, filter, find, findIndex, get, groupBy, map, update } from 'lodash';
import { getNumberMask } from 'utils/lib/ebookHelper';
import { handleCreateBookmarks, handleDeleteBookmarks, handleUpdateBookmarks, handleListClassBookmarks } from 'store/bookmark/thunks';
// import { makeStyles } from 'utils/styles/mui';
import { openSlideWidgetAction } from 'store/slides/actions';
import { updateUI } from 'store/UI/actions';
import { useAiAnswerView, useAnswerView, useMainbookView, useStoryView, usePDFView } from 'store/main_book_popup/selectors';
import { useMatchMakingView } from 'store/main_book_popup/selectors';
import { useApExams } from 'store/apexams/selectors';
import { useBookmarks } from 'store/bookmark/selectors';
import { useChapterArticleLevel, useOneStoryWithAi } from 'store/StoryAiCofig/selectors';
import { useDemoStatus } from "store/users/selectors";
import { useExams } from 'store/exams/selectors';
import SentryWrap from 'components/Sentry';
import { useFullScreen } from 'utils/context/FullScreenProvider';
import { useFullScreenTabDetect, useTabletDetection } from 'containers/chat/hooks';
import { useGetAllSlidesData } from 'store/slides/selectors';
import { useOrientation } from 'components/hooks';
import { usePageVocabContent } from 'store/page_translations/selectors';
import { useSideDrawer } from 'utils/context/SideDrawerProvider';
import { useTimmerRunning } from 'store/timmer/selectors';
import { useUI } from 'store/UI/selectors';
import { BackButtonEbook } from 'components/UI/buttons/Backbutton';
import CognatesHandler from 'modules/word_bank/teacher/cognates';
import { debounceMath } from 'utils/methods/math';
import usePopUpAtOnce from 'components/hooks/usePopUpAtOnce';
import useSoyHistoriasNotification from 'components/hooks/useSoyHistoriasNotification';
import { useStandardExams } from 'store/standardexams';
import SuperLessonDiffList from 'modules/superLessonDiffList';
import useIsExamActive from 'components/hooks/books/useIsExamActive';
import EngageView from 'modules/engageFeature/teacher/engageView';
import { useBookDataUnits } from 'components/hooks/books/useBookDataUnits';
import EngageButton from 'modules/engageFeature/teacher/engageButton';
import { handleLearningModuleCount } from 'store/bingo/thunks';
import { isErrorContent } from "utils/methods/storyContentValidation";
import useStoryViewOpen from 'components/hooks/useStoryViewOpen';
import { logToSentry } from 'utils/networkErrorUtils';
import { redirectToHome } from 'utils/config/navigation';

const cache_random =Math.floor(Math.random()*1000000)
//  ----------------------------------------------------------------------------
//  Styles
//  ----------------------------------------------------------------------------
const ButtonContainer = styled.button`
  background-color: transparent;
  border: none;
  color: ${COLOR.black600};
  cursor: pointer;
  outline: none;
  position: fixed;
  top: 50%;
  transition: all 300ms ease;
  z-index: 100;

  ${({ left }) => left !== undefined && `left: ${left}px;`}
  ${({ right }) => right !== undefined && `right: ${right}px;`}

  @media only screen and (max-width: 768px) {  // Mobile
    ${({ mobileLeft }) => mobileLeft !== undefined && `left: ${mobileLeft}px;`}
    ${({ mobileRight }) => mobileRight !== undefined && `right: ${mobileRight}px;`}
  }

  @media only screen and (min-width: 769px) and (max-width: 1024px) { // Tablet
    ${({ tabletLeft }) => tabletLeft !== undefined && `left: ${tabletLeft}px;`}
    ${({ tabletRight }) => tabletRight !== undefined && `right: ${tabletRight}px;`}
  }

  @media only screen and (min-width: 1025px) { // Desktop
    ${({ left }) => left !== undefined && `left: ${left}px;`}
    ${({ right }) => right !== undefined && `right: ${right}px;`}
  }
`;


const Container = styled.div`
    align-items: stretch;
    display: flex;
    flex-direction: column;
    margin: 0px auto;
    // max-width: 1268px;
    // max-width: 1350px;
    max-width: 1450px;
    padding: 64px 0px 0px;
    position: relative;
    width: 100%;

    @media only screen and (max-width: 1367px){
        padding: 0px 0px 0px;
    }

    @media (min-width: 809px) {
        flex-direction: row;
        // padding: 0px 30px;
    }
     @media (max-width:1200px) {
        // flex-direction:column;
     }
`;

const Images = styled.img`
    background-color: ${COLOR.white};
    box-shadow: 0 10px 20px rgba(0,0,0,0.19), 0 6px 6px rgba(0,0,0,0.23);
    height: auto;
    width: 100%;
`;

const ImageContainer = styled.div`
    height: fit-content;
    flex: 1;
    position:relative;
    transition: all 0.3s ease-in-out;
    width: ${props => props.isDrawerOpen ? '0%' : '100%'};
    opacity: ${props => props.isDrawerOpen ? '0' : '1'};
    overflow: visible;
    visibility: ${props => props.isDrawerOpen ? 'hidden' : 'visible'};
    display: ${props => props.isDrawerOpen ? 'none' : 'block'};
    @media only screen and (max-width: 1200px){
        // padding-left: 40px;
        // padding-right: 40px;
    }
    @media only screen and (max-width: 450px){
        // padding-left: 20px;
        // padding-right: 20px;
    }
`;

const NavContainer = styled.div`
    display: none;

    @media (min-width: 997px) {
        align-items: flex-end;
        display: flex;
        flex-direction: column;
        margin-right: 8px;
        width: 24px;
    }

    @media (min-width: 1192px) {
       align-items: flex-end;
        display: flex;
        flex-direction: column;
        margin-right: 16px;
        width: 24px;
    }
     @media (min-width: 997px) and (max-width:1366px) {
        display:none;
     }
`;

const NavItemOverflow = styled.div`
    display: inline-table;
    overflow: hidden;
    transition: width 300ms ease 500ms;
    // width: 60px;
    // @media (min-width: 997px) and (max-width:1366px) {
    //     width:100%;
    // }
`;

const NavItem = styled.button`
    background-color: ${p => p.active ? COLOR.indigo100 : COLOR.green900};
    border: none;
    border-radius: 2px;
    // box-shadow: ${p => p.active && '0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23)'};
    color: ${p => p.active ? COLOR.white : COLOR.white};
    //  border-radius: ${p => p.active ? '12px' : '12px'};
    cursor: pointer;
    /* display: initial; */
    flex-direction: row;
    font-size: 0.85em;
    font-weight: 600;
    margin-bottom: 0px;
    outline: none;
    padding: 8px;
    transition: all 300ms ease;
    border-bottom: 1px solid #ffffff87;
    text-align:left;
    &:hover {
        box-shadow: ${p => p.active && '0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23)'};
    }
    
    &:hover ${NavItemOverflow} {
        /*   width: ${p => p.active ? '8px' : '49px'}; */
        width: '49px'};
    }
    @media (max-width: 1366px) {
        background-color: ${p => p.active ? COLOR.indigo100 : 'transparent'};
        color: ${p => p.active ? 'white' : '#252F4A'};
        text-align:left;
        display:flex;
        align-items:center;
    }
`;


const ToolsContainer = styled.div`
    height: 100%;
    width: 100%;
    flex: 1;
    transition: width 0.3s ease-in-out, transform 0.3s ease-in-out;
    width: ${props => props.isDrawerOpen ? '90%' : '100%'};
    // transform: ${props => props.isDrawerOpen ? 'translateX(0)' : 'translateX(0)'};
    // max-width: 469px;

    @media (max-width: 1200px){
    margin-top: 45px;
    }

    @media (min-width: 1200px){
        // max-width: unset;
            margin-top: 48px;
                max-width: 485px;
    }
    
    @media (min-width: 1200px) {
        margin-left: 11px;
        margin-top: 0px;
        width: 322px;
    }
    @media (min-width: 1200px) {
        // margin-left: 48px;
        margin-left: 16px;
        margin-top: 0px;
        width: 330px;
    }
    // @media (min-width: 992px) and (max-width: 1280px) and (min-height: 600px) and (max-height: 1370px) {
    @media (min-width: 992px) and (max-width: 1280px) {
        width: 377px;
        flex: unset;
        margin-top: 0px !important;
    }
    @media (min-width: 809px) and (max-width: 991px){
        width:355px;
        flex: unset;
        margin-top: 0px !important;
    }
`;

const Wrapper = styled.div`
    display: flex;
    padding: 10px 0px 50px 0;
    margin-bottom: 20px;
    position: relative;
    width: 100%;
    @media (min-width: 997px) and (max-width:1366px){
        padding-top:20px;
    }
`;
const MainWrapper = styled.div`
    padding-left:24px;
    padding-right:24px;
@media only screen and (max-width: 1200px){
    padding-left:0px;
    padding-right:0px;
}
`
const ItemWrapper = styled.div`
    display: flex;
   flex-direction:row;
  
`;
const ListItem = styled.li`
    list-style-type: none;
    display: flex;
    background-color: ${p => p.active ? COLOR.indigo100 : "#006b6e"};
    border: none;
    border-radius: 2px;
    box-shadow: ${p => p.active && '0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23)'};
    color: ${p => p.active ? COLOR.white : COLOR.white};
    // border-radius: ${p => p.active ? '12px' : '12px'};
    cursor: pointer;
    /* display: initial; */
    flex-direction: row;
    font-size: 0.75em;
    font-weight: 600;
    margin-bottom: 0px;
    outline: none;
    padding: 8px;
    transition: all 300ms ease;
    justify-content:center;
    text-align:center;
    border-bottom: 1px solid #ffffff47;
    &:hover {
        box-shadow: ${p => p.active && '0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23)'};
    }

    &:hover ${NavItemOverflow} {
    /*   width: ${p => p.active ? '8px' : '49px'}; */
        width: '49px'};
    }
       @media (max-width: 1366px) {
        background-color: ${p => p.active ? COLOR.indigo100 : 'transparent'};
        color: ${p => p.active ? COLOR.white : 'black'};
        text-align:left;
        padding-left:16px;
    }
`
const List = styled.ul`
    padding: 0px;
    margin-top: 0px;
    margin-bottom: 0px;
    display: block;
    width: 100%;
`
const ModalContent = styled.div`
    align-items: center;
    background-color: ${COLOR.white};
    border-radius: 3px;
    display: inline-flex;
    flex-direction: column;
    left: 50%;
    max-width: 320px;
    padding: 16px;
    position: absolute;
    text-align: center;
    top: 50%;
    transform: translate(-50%, -50%);
`;

const ModalRow = styled.div`
    align-items: center;
    display: flex;
    flex-direction: row;
    justify-content: center;
    margin-top: 16px;
    width: 100%;
`;
const BookmarkLinkWrapper = styled.div`
    color: rgba(0, 0, 0, 0.87);
    font-size: 0.875rem;
    box-sizing: border-box;
    transition: background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,border 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
    font-family: "Roboto", "Helvetica", "Arial", sans-serif;
    font-weight: 500;
    line-height: 1.75;
    border-radius: 0px;
    letter-spacing: 0.02857em;
    text-transform: uppercase;
    display:flex;
    flex-direction:row;
`;
const TrashButton = styled.button`
    padding: 2px;
    border: none;
    justify-content: center;
    align-items: center;
    display: flex;
    cursor: pointer;
`;
const MarkButton = styled.button`
    padding: 2px;
    border: none;
    justify-content: center;
    align-items: center;
    display: flex;
    cursor: pointer;
`;
const ActivityBtn = styled.button`
    border: none;
    justify-content: center;
    align-items: center;
    display: flex;
    cursor: pointer;
    background-color: #012B70;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    color: #fff;
    // border-radius: 0px;
    font-size: 12px;
    height: 36px;
    width: 55.8px;
    padding-inline: 11px;
    padding-top: 10px;
    padding-bottom: 9px;
    margin-left:2px;
`;
const FullScreenBtn = styled.button`
    border: none;
    justify-content: center;
    align-items: center;
    display: flex;
    cursor: pointer;
    background-color: #012B70;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    color: #fff;
    // border-radius: 0px;
    font-size: 12px;
    height: 36px;
    width: 40.8px;
    padding-inline: 11px;
    padding-top: 10px;
    padding-bottom: 9px;
    margin-left:2px;
   }
`;
const AddBookmarkButton = styled.button`
    // padding: 2px;
    border: none;
    justify-content: center;
    align-items: center;
    display: flex;
    cursor: pointer;
    background-color:${COLOR.green};
    // padding-right: 10px;
    // padding-left: 5px;
    color: #fff;
    border-radius: 0px;
    font-size: 12px;
    width: 40.8px;
    height: 36.1px;
    padding-right:1px;
`;
const MobileBar = styled.div`
`;
const MobileMenu = styled.div`
`;
const ButtonLink = styled.button`
    border:none;
    background-color:${COLOR.green};
    padding:4px;
    color:white;
    border-radius:8px 8px 0 0;
    padding:6px 8px;
    margin-right:5px;
`;



const Title = styled.span`
    display: inline-block;
    display: inline-block;
    background-color: #ff682c;
    color: #ffffff;
    font-size: 12px;
    border-radius: 7px;
    padding: 4px 13px 4px 26px !important;
    font-weight: 500;
    line-height: 18px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    border: none;
    left: 45%;
    outline: none;
    position: absolute;
    top: 10px;
    transition: all 300ms ease;
    z-index: 1;
`;
const BookMarkWrapper = styled.div`
  display: flex !important;
`;
const Wrap = styled.div`
    align-items: center;
    border-bottom: 1px dashed ${COLOR.black800};
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    padding: 8px 0px;
    flex-wrap:wrap;
`;
// const useStyles = makeStyles({
//     root: {
//         // margin: '5px',
//         // width: '175px'
//     },
//     sizeSmall: {
//         // width: '55px',
//         // height: '25px'
//     },
//     checkedSwitch: {
//         transform: 'translateX(20px) !important'
//     },
//     label: {
//         textTransform: 'uppercase',
//     },
// });
const BackButton = styled.button`
    background-color: ${COLOR.indigo200};
    width: max-content;
    color: ${COLOR.white};
    border: none;
    outline: none;
    padding: 5px 0px;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    padding-left: 8px;
    padding-right: 8px;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    @media (max-width: 450px) {
        padding-left: 0px;
    padding-right: 3px;
    }
   `
   const BackText = styled.span`
   display: inline;
 
   @media (max-width: 1200px) {
     display: none;
   }
 `;
 
 const ShortBackText = styled.span`
   display: none;
 
   @media (max-width: 1200px) {
     display: inline;
   }
 `;

const PacingButton = styled.button`
  background: linear-gradient(to right, #f45c43, #ffb347);
  color: white;
  border: none;
  border-radius: 2px;
  padding: 8px;
  margin: 0px 0px 1px 0;
  width: 95px;
  text-align: left;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  transition: transform 0.2s ease;
    @media Screen and (max-width: 1200px) {
        text-align:left;
    }
//   &:hover {
//     transform: translateY(-1px);
//   }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 2px rgba(255, 179, 71, 0.4);
  }
`;
const PackingContainer = styled.div`
    background: white;
    height: 93%;
    width: 100%;
    position: absolute;
    top: 36px;
`;
const DropdownWrapper = styled.div`
  position: absolute;
  top: 38px;
  z-index: 990;
  background: #ffffff;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.12);
  border-radius: 6px;
  padding: 8px 0;
  min-width: 260px;
`;
const DropdownItem = styled.div`
  padding: 8px 12px;
  font-size: 14px;
  font-weight: 500;
  color: #1e1e1e;
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: #f4f4f4;
  }

  &:not(:last-child) {
    border-bottom: 1px solid #f0f0f0;
  }
`;

const VerticalScrollContainer = styled.div`
  height:100%;
  width: 100%;
  padding: 16px;
  background-color: white;
  border-radius: 8px;
  overflow-y: auto;
  overflow-x: hidden;
  box-sizing: border-box;

  /* Hide scrollbars */
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
  &::-webkit-scrollbar {
    display: none; /* Chrome, Safari, Opera */
  }
`;

const ImageItem = styled.img`
  width: 100%;
  height: auto;
  object-fit: cover;
  border-radius: 8px;
  margin-bottom: 16px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  display: block;
`;
const MobileContainer = styled.div`
    width:100%;
    margin:0 auto;
    display:flex;
    align-items:center;
    flex-direction:column;
    button{
        width:100% !important;    
    }
`;
const AnimatedArrowContainer = styled.div`
margin: 0 auto;
text-align: center;
width: 56px;
height: 56px;
position: relative;
cursor: pointer;
filter: url("#goo");
`;

const AnimatedArrowWrapper = styled.div`
display: flex;
justify-content: center;
gap: 20px;
`;

const ArrowCircle = styled.div`
background: linear-gradient(to right, #f45c43, #ffb347);
border-radius: 50%;
display: inline-block;
height: 56px;
width: 56px;
position: absolute;
top: 50%;
left: 50%;
transform: translateX(-50%) translateY(-50%);
transform-origin: 0%;
`;

const ArrowCircleTop = styled(ArrowCircle)`
height: 18.67px; // 33.33% of 56
width: 18.8px;   // ~55% of 56
animation: blob-1-anim 3s cubic-bezier(0.77, 0, 0.175, 1) infinite;
z-index: 0;
top: 0;
`;

const ArrowCircleBottom = styled(ArrowCircle)`
height: 30.8px;
width: 30.8px;
animation: blob-2-anim 3s cubic-bezier(0.77, 0, 0.175, 1) infinite;
z-index: 9;
top: 10px;
`;

const ArrowSvg = styled.svg`
z-index: 9;
position: relative;
background: linear-gradient(to right, #f45c43, #ffb347);
border-radius: 50%;
display: inline-block;
height: 56px;
width: 56px;

.st-arrow {
    fill: #fff;
    animation: scrolly 3s cubic-bezier(0.77, 0, 0.175, 1) forwards infinite;
    perspective: 9000px;
    transform: translateZ(0);
    transform-origin: bottom;
}
`;

const AnimatedArrowBottom = styled.div`
width: 100%;
height: 100%;
position: relative;
transform: ${props => props.isAtBottom ? 'rotate(180deg)' : 'rotate(0deg)'};
transition: transform 0s ease;
`;
//  ----------------------------------------------------------------------------
//  Feature
//  ----------------------------------------------------------------------------
//
//  Ebook
//
//  -- Description
//  Ebook display component
//
//  -- Props
//  ...
//
//  -- State
//  ...
//
//  -- Methods
//  ...
//
//  -- Usage
//  ...
//
const EbookLayout = ({
    classUsers,
    activity,
    chapter,
    data,
    page,
    quiz,
    ebookFlag,
    setEbookFlag,
    ebookFlagTeacherEdition,
    setEbookFlagTeacherEdition,
    tips,
    existTeacherEdition,
    existShowAnswer,
    existAssignmentLink,
    submissions,
    currentUser,
    classActivities,
    classQuizzes,
    lessonPlan,
    SuperLesson,
    DifferentiationLesson,
    sentenceStarterData,
    rubrics,
    assignmentPlan,
    workbook_plan,
    main_book,
    booksAllList,
    currentClass,
    ai_content,
    book,
    dataBook
}) => {
    const {checkPopUpAtOnce,updatePopUpAtOnce} = usePopUpAtOnce();
    const showAlert = useAlert();
    const orientation = useOrientation();
    const isTablet = useFullScreenTabDetect();
    const isTabletDevice = useTabletDetection();
    const landscapeOrientation = useOrientationFullScreen();
    const getStoryWithAi = useOneStoryWithAi();
    const { storyView } = useStoryView();
    const { currentFullScreen, FullScreenMode, ExitFullScreenMode } = useFullScreen();
    const [checkInstructionDataForStudent, setCheckInstructionDataForStudent] = useState(false);
    const [toolsDropdown, setToolsDropdown] = useState(false);

    const [hasStoryWithAi, setHasStoryWithAi] = useState({});
    const [openStoryWithAi, setOpenStoryWithAi] = useState(false);
    const [openStoryWithAiView, setOpenStoryWithAiView] = useState(false);
    
    const [handleStoryId, setHandleStoryId] = useState('');
    const [handleStoryStream, setHandleStoryStream] = useState('');
    const [handleStoryStreamTitle, setHandleStoryStreamTitle] = useState('');
    
    const [showStoryModal, setShowStoryModal] = useState(false);

    const [openSuperLessonToolModal, setOpenSuperLessonToolModal] = useState(false);
    const [openDiffernationToolModal, setOpenDiffernationToolModal] = useState(false);
    const [imageConfiguration, setImageConfiguration] = useState({});
    const [showSuperLessonAlert, setSuperLessonAlert] = useState(false);
    const [WarningPrint, setWarningPrint] = useState(false);
    const [removeBookMark, setRemoveBookMark] = useState(false);
    const [CheckTerms, setCheckTerms] = useState(false);
    const [showSpecialSupport, setShowSpecialSupport] = React.useState(false);
    const [studentViewFlag, setStudentViewFlag] = React.useState(false);
    const dispatch = useDispatch()
    const isStoryViewOpen = useStoryViewOpen();
    const [printLoader, setPrintloader] = useState(false)
    const bookHyperlinks = get(find(booksAllList, ['id', chapter]), "hyperlinks")
    const pacingTeacher = get(find(booksAllList, ['id', chapter]), "pacingTeacher")
    const syllabusTeacher = get(find(booksAllList, ['id', chapter]), "syllabusTeacher")
    const pageHyperlink = get(find(bookHyperlinks, p => p.page == page), "links")
    const is_non_spanish = useMemo(() => book?.book_type === "non_native_spanish", [book]) 
    const backBtnRef = useRef(null)
    const forwardBtnRef = useRef(null)
    const location = useLocation();
  	const navigate = useNavigate();
    const timmerRef = useRef(null)
    const timeIntRef = useRef(0)
    const timeStoreRef = useRef('time_to_calc')
    const clearPreviewRef = useRef(null)
    const [activeTab, setActiveTab] = useState(-1)
    const [expandedLessonIndex, setExpandedLessonIndex] = useState(null)
    const [timeInt, setTimeInt] = useState(0)
    const submitRef = useRef(null)
    const generateUrl = (page) => `/ebook?chapter=${chapter}&page=${page}&activity=${activity ?? null}&quiz=${quiz ?? null}`;
    const demoPages = get(find(booksAllList, ["id", chapter]), "demoPages")
    const chapterActivities = groupBy(classActivities, 'data.chapter');
    const chapterQuizzes = groupBy(classQuizzes, 'data.chapter');
    const demoStatus = useDemoStatus()
    const classBookmark = useBookmarks()
    const bookBookmarks = find(classBookmark, ["bookId", chapter])
    const [bookmarkloader, setbookmarloader] = useState(false)
    const [aiModals, setAiModals] = useState(false);
    const [studyModals, setStudyModals] = useState(false);
    const [examBookIds, setExamBookIds] = useState([])
    const page_1game_ai_content = useMemo(() => (find(ai_content, k => parseInt(k.start_page) <= parseInt(page) && parseInt(k.end_page) >= parseInt(page))), [ai_content, page])
    let tipsFiltered = [];
    if (tips.length != undefined) {
        tipsFiltered = filter(tips, x => x.page === page);
    }
    const [deleteBookmarkloader, setDeleteBookmarloader] = useState(false)
    const [vocModal, setVocModal] = useState(false);
    const [phrasesModal, setPhrasesModal] = useState(false);
    const [cogModal, setCogModal] = useState(false);
    const [instModal, setInstModal] = useState(false);
    const [, setTimmerRunning, clearTimmerRunning] = useTimmerRunning()
    const [isNavigating, setIsNavigating] = useState(false);
    // const getNumberMask = useCallback((_page) => get(find(get(find(booksAllList, { id: chapter }), "pages"), k => k.pageId == _page), "NumberMasked", _page), [chapter, booksAllList, classBookmark])
    const exams = useExams();
    const standard_exams = useStandardExams();
    const examsAp = useApExams();
    
    const isExam = useMemo(() => {
      const flatExams = exams?.flatMap((entry) => entry.exams.map((exam) => `${exam.bookId}`)) || [];
      const flatApExams = examsAp?.flatMap((entry) => entry.exams.map((exam) => `${exam.bookId}`)) || [];
    
      return flatExams.includes(`${chapter}`) || flatApExams.includes(`${chapter}`);
    }, [exams, examsAp, chapter]);
    const isStandardExam = useMemo(() => checkStandardExam(chapter,standard_exams), [chapter, standard_exams]);

    const isOnlyForTeacher = !!book?.onlyTeacher 
    const book_tips = useMemo(() => filter(tips, x => x.bookId == chapter), [chapter]);
    const page_tips = useMemo(() => filter(book_tips, x => x.page == page), [book_tips, page]);
    const { answerView, revokeAnswerView } = useAnswerView();
    const { revokePDFView } = usePDFView();
    const { revokeMainbookView } = useMainbookView()
    const [open, setOpen] = React.useState(false);
    const [popupMessage, setPopupMessage] = React.useState('');
    const [viewLesson, setViewLesson] = useState(false);
    const [viewLessonDifferentiation, setViewLessonDifferentiation] = useState(false);
    const [viewLessonType, setViewLessonType] = useState("");
    const [viewLessonTypeValue, setViewLessonTypeValue] = useState("");
    const [viewLessonTypeDiff, setViewLessonTypeDiff] = useState("");
    const [viewStreamLesson, setViewStreamLesson] = useState("");
    
    const [isStream, setIsStream] = useState(false);
    
    const [superLessonOpen, setSuperLessonOpen] = useState(false);
    const [differentiationOpen, setDifferentiationOpen] = useState(false);
    const [storyCreateOpen, setStoryCreateOpen] = useState(false);
    const is_non_roman = useMemo(() => {
        const mask = getNumberMask(chapter, page, booksAllList);
        return isNaN(mask);
    }, [page, chapter, booksAllList]);

    const [assignmentAiModal, setassignmentAiModal] = useState(false);
    const [shareWithMe, setShareWithMe] = useState(false);
    const [shareByMe, setShareByMe] = useState(false);
    const [generateVocabActivity, setGenerateVocabActivity] = useState(false);
    const { isDrawerOpen, openDrawer, closeDrawer, toggleDrawer } = useSideDrawer();
    const { matchMakingView , matchMakingFullScreenOpen, revokeMatchMakingFullScreenClose} = useMatchMakingView();
    const [isMatchMakingAssignment, setIsMatchMakingAssignment] = useState(matchMakingView);
    // const classes = useStyles();
    const isCanvasUser  = !!get(currentUser,"canvas_id")
    const is_district_admin = useMemo(()=>get(currentUser,"role")=='admin',[currentUser])
    const { revokeAiAnswerView } = useAiAnswerView()
    const { book_vocb_content } = usePageVocabContent()
    const page_vocab_content = useMemo(()=>{
        if(!book_vocb_content) return null;
        return book_vocb_content.find(k=>{
            if(k.chapter != chapter) return false;
            if(k.page == page) return true;
            return k.content?.some(item => {
                const from = parseInt(item.from_page), to = item.to_page ? parseInt(item.to_page) : null;
                const curr = parseInt(page);
                return to ? curr >= from && curr <= to : curr === from;
            });
        });
    },[book_vocb_content, chapter, page])
    const getAllSlideData = useGetAllSlidesData();
    const page_slide = useMemo(() =>getAllSlideData?.find((x) => x.book_id == chapter && x.page_id == page) || {}, [chapter, page, getAllSlideData])
    const [openWidgetCount, setOpenWidgetCount] = useState(0);
    const [openNotesCount, setOpenNotesCount] = useState(0);
    useEffect(() => {
        if (typeof window === "undefined") {
            return;
        }
        const handler = (event) => {
            const { target, open } = event.detail || {};
            if (target === "widget") {
                setOpenWidgetCount((prev) => {
                    if (open) {
                        return prev + 1;
                    }
                    return Math.max(0, prev - 1);
                });
            }
            if (target === "notes") {
                setOpenNotesCount((prev) => {
                    if (open) {
                        return prev + 1;
                    }
                    return Math.max(0, prev - 1);
                });
            }
        };
        window.addEventListener("draggable-widget-toggle", handler);
        return () => {
            window.removeEventListener("draggable-widget-toggle", handler);
        };
    }, []);
    const showWidgetZIndex = openWidgetCount > 0;
    const showNotesZIndex = !showWidgetZIndex && openNotesCount > 0;
    // Article state start
    const article_levels = useChapterArticleLevel();
    const book_articles = useMemo(() => Array.isArray(article_levels) ? article_levels.filter((item) => item.chapter == chapter) : [], [chapter, article_levels]);
    const page_articles = useMemo(() => Array.isArray(book_articles) ? book_articles.filter((item) => item.page == page) : [], [book_articles, page]);
    const [openArticleLevel, setOpenArticleLevel] = useState(false);
    // Article state end
    const isApExams = Boolean(find(examsAp, k => find(k.exams, c => c.bookId == chapter)))
    const [pacingModal,setPacingModal] = useState(false); 
    const [syllabusModal, setSyllabusModal] = useState(false); 
    const UI = useUI();

    // Add state for tracking first image visibility
    const [showAnimatedArrow, setShowAnimatedArrow] = useState(true);
    const syllabusContainerRef = useRef(null);
    const firstImageRef = useRef(null);

    // For pacing guide
    const [showPacingArrow, setShowPacingArrow] = useState(true);
    const pacingContainerRef = useRef(null);
    const firstPacingImageRef = useRef(null);
    const {checkApExamBookType,checkStandardExamBookType} = useIsExamActive();
    const currentPageIndex = useMemo(() => {
        const pages = data?.content || [];
        const pageIndex = pages.findIndex(p => p.pageId == page);
        return pageIndex;
    }, [page, data]);
    const {getAllEngageOptionBetweenUnit} = useBookDataUnits(chapter,page, book?.engage);
    
    const handlerOpen = async (value) => {
        const widgetData = {
            open: true,
            pageId: page,
            bookId: chapter,
            data: page_slide
        };
        await dispatch(openSlideWidgetAction(widgetData));
    };

    useEffect(() => {
        if (openArticleLevel) {
            setOpenArticleLevel(false);
        }
    },[page])

    useEffect(() => {
      const filterByPage = filter(
        getStoryWithAi,
        (item) => {
          const pageMatch = parseInt(item.page) === parseInt(page);
          const isNotError = !isErrorContent(item?.story_content || '');
          return pageMatch && isNotError;
        }
      ) || {};
      setHasStoryWithAi(filterByPage);
    }, [page, getStoryWithAi]);

    useEffect(() => {
        const fetchBookmarks = async () => {
            if (currentClass?.id) {
                await dispatch(handleListClassBookmarks(currentClass.id));
            }
        };
        fetchBookmarks();
    }, [currentClass?.id, chapter, dispatch]);

useSoyHistoriasNotification({
  page,
  chapter,
  hasStoryWithAi,
  setHasStoryWithAi,
  openStoryWithAi,
  setOpenStoryWithAi,
  setOpenStoryWithAiView,
});



    const handleOpenStoryWithAi = (type) => {
        if(!type && checkPopUpAtOnce()) return;
        updatePopUpAtOnce(true);
        if(handleForDistrictAdmin()) return;
        if (window.innerWidth >= 744) {
            // For larger screens, check if SuperLesson or Differentiation is open
            if (superLessonOpen) {
                setPopupMessage("Please close the SuperLesson, to open the Story AI");
                setOpen(true);
                return;  // Exit early if SuperLesson is open
            } else if (differentiationOpen) {
                setPopupMessage("Please close the Differentiation, to open the Story AI");
                setOpen(true);
                return;  // Exit early if Differentiation is open
            }
        }

        // For both large and small screens, continue with opening the AI Story
        if (hasStoryWithAi?.length > 0 && type !== "more_story") {
            setOpenStoryWithAi(true);
            setOpenStoryWithAiView(true);
        } else {
            setShowStoryModal(true);  // Show modal if no story is available
        }

        // Close tools dropdown and toggle story creation view
        setToolsDropdown(false);
        setStoryCreateOpen(!storyCreateOpen);
    };

    useLayoutEffect(() => {
        closeDrawer();
        onClose();
    }, [orientation]);

    const hasSuperLessonPage = useMemo(() => {
        if (!SuperLesson || !data?.content) return null;
        const pages = data.content;
        return find(SuperLesson, (p) => {
            const fromIndex = pages.findIndex(x => x.pageId == p.from);
            const toIndex = pages.findIndex(x => x.pageId == p.to);
            return currentPageIndex >= fromIndex && currentPageIndex <= toIndex && fromIndex >= 0 && toIndex >= 0;
        });
    }, [SuperLesson, currentPageIndex, data?.content]);

    const hasDifferentiationLessonPage = useMemo(() => {
        if (!DifferentiationLesson || !data?.content) return null;
        const pages = data.content;
        return find(DifferentiationLesson, (p) => {
            const fromIndex = pages.findIndex(x => x.pageId == p.from);
            const toIndex = pages.findIndex(x => x.pageId == p.to);
            return currentPageIndex >= fromIndex && currentPageIndex <= toIndex && fromIndex >= 0 && toIndex >= 0;
        });
    }, [DifferentiationLesson, currentPageIndex, data?.content]);

    const showCopyRight = () => {
        setPopupMessage("Content is protected!")
        setOpen(true);

    }
    const [learnPlanModal, setLearnPlanModal] = useState(false)
    const showAdoption = () => {
        setPopupMessage("Available after adoption")
        setOpen(true);
    }
    const handleClose = () => {
        setOpen(false);
    };

    useEffect(() => {
        let examsBookId = exams?.flatMap(k => k.exams).map(n => `${n.bookId}`)
        setExamBookIds(examsBookId)
    }, [])

    const [opens, setOpens] = useState(false);
    const [size, setSize] = useState();
    const showDefaultDrawer = () => {
        setSize('default');
        setOpens(true);
    };
    const showLargeDrawer = () => {
        if (data?.structures?.length > 0) {
            setSize('large');
            setOpens(true);
        } else {
            setPopupMessage('No units were found in this book.')
            setOpen(true);
        }
    };
    const onClose = () => {
        setOpens(false);
    };


    const getSrcPage = useCallback((page) => {
        let dataPage = find(data?.content, x => x.pageId == Number(page));
        let url = "";
        if (dataPage) {
            url = typeof dataPage.src === "string" ? dataPage.src : "";
            if(url.includes("imagedelivery.net")){
                if(url.includes("?")){
                    url = url + "&quality=100&format=jpeg&cache=" + cache_random;
                }else{
                    url = url + "?quality=100&format=jpeg&cache=" + cache_random;
                }
            }
        }
        return url;
    }, [data, page, ebookFlagTeacherEdition, ebookFlag])

    const setFlagsFalse = () => {
        setStudentViewFlag(false);
        setShowSpecialSupport(false);
        setEbookFlag(false);
        setEbookFlagTeacherEdition(false);
    }

    const imageRef = useRef();

    const handleImagePrint = () => {
        onValidPrintable()
    }
    const handleCheckTerms = (e) => {
        setCheckTerms(e.target.checked);
    }
    const SendCheckTerms = () => {
        if (CheckTerms) {
            setWarningPrint(false);
            onValidPrintable()
        }
        else {
            setPopupMessage("Acepta los Terminos y Condiciones para Continuar.")
            setOpen(true);
        }
    }
    const onValidPrintable = () => {
        addPrintableClass()
        validationPrint()
    }
    const validationPrint = useReactToPrint({
        contentRef: imageRef,
        onBeforeGetContent: async () => { setPrintloader(true) },
        onBeforePrint: async () => {
            setPrintloader(false);
        },
        onAfterPrint: async () => {
            removePrintableClass()
        },
    });


    useEffect(() => {
        if (!answerView?.open) {
            setEbookFlag(false);
        }
    }, [answerView]);

    useEffect(() => {
        if (demoStatus && demoPages && data?.content) {
            const pages = data.content;
            const demoFromIndex = pages.findIndex(p => p.pageId == demoPages.from);
            const demoToIndex = pages.findIndex(p => p.pageId == demoPages.to);
            const is_demo_set = demoFromIndex>=0 && demoToIndex>=0 && demoFromIndex<=demoToIndex;
            if (is_demo_set && (currentPageIndex < demoFromIndex || currentPageIndex > demoToIndex)) {
                //TODO disabled for now
                // navigate(redirectToHome(currentUser) || '-1')
                setPopupMessage("Restricted access (legend)")
                setOpen(true);
            }
        }
    }, [demoStatus, demoPages, currentPageIndex, data?.content])
    useEffect(() => {
        document.addEventListener('keydown', checkKey);
        return () => {
            document.removeEventListener("keydown", () => { })
        }
    }, [])
    useEffect(() => {
        preloadImage()
    }, [data])
    useEffect(() => {
        if (currentUser?.role != 'student') return;
        try {
            let actAct = find(chapterActivities[chapter], x => (get(x, "data.id") === activity))
            let actqz = find(chapterQuizzes[chapter], x => (get(x, "data.id") === quiz))
            if (!actAct && activity && activity !== 'null') {
                actqz = find(chapterQuizzes[chapter], x => (get(x, "data.id") === activity))
            }
            let Actdata = find(submissions, ['assignmentId', get(actAct, "activityId")])
            let qzdata = find(submissions, ['assignmentId', get(actqz, "quizId")])
            let _timmer = 0
            let _durration = 0;
            if (activity && typeof activity === "string" && activity != "null" && activity != "undefined" && actAct) {
                _durration = actAct.timeDuration
                timeStoreRef.current = activity
                let past_time = sessionStorage.getItem(timeStoreRef.current)
                if (Actdata) {
                    if (!Actdata.complete) {
                        _timmer = Actdata.timmer
                    }
                    if (past_time) {
                        _timmer = past_time
                    }
                    handleTimmer(_durration, _timmer)
                } else {
                    if (past_time) {
                        _timmer = past_time
                    }
                    handleTimmer(_durration, _timmer)
                }

            } else if (activity && typeof activity === "string" && activity != "null" && activity != "undefined" && actqz) {
                _durration = actqz.timeDuration
                timeStoreRef.current = activity
                let past_time = sessionStorage.getItem(timeStoreRef.current) 
                if (qzdata) {
                    if (!qzdata.complete) {
                        _timmer = qzdata.timmer

                    }
                    if (past_time) {
                        _timmer = past_time
                    }
                    handleTimmer(_durration, _timmer)
                } else {
                    if (past_time) {
                        _timmer = past_time
                    }
                    handleTimmer(_durration, _timmer)
                }
            }

        } catch (error) {
            Sentry.captureException(`518 Error in useEffect: ${error}`);
            console.log(error, "errr")
        }

    }, [activity, quiz, classQuizzes, classActivities,currentUser])
    const handleTimmer = (timeDuration, timer) => {
        try {
            if (timeDuration && !isNaN(parseInt(timeDuration)) && parseInt(timeDuration) > 0) {
                let _timer = (typeof timer === "number" && timer > 0) ? timer 
                : (parseInt(timer) > 0 ? parseInt(timer) 
                : parseInt(timeDuration) * 60);
                if (timmerRef.current) { onFinish(true) };
                timeIntRef.current = _timer;
                setTimmerRunning()
                timmerRef.current = setInterval(() => {
                    if (timeIntRef.current > 0) {
                        timeIntRef.current = timeIntRef.current - 1
                        let timePrint = moment.utc(timeIntRef.current * 1000).format('HH:mm:ss');
                        if(timeStoreRef.current){
                            sessionStorage.setItem(timeStoreRef.current, timeIntRef.current)
                        }
                        setTimeInt(timePrint)
                    } else {
                        if (typeof submitRef.current == "function") {
                            submitRef.current(true, null, false, null, true)
                            submitRef.current = null
                            onFinish()
                        }
                    }
                }, 1000)
            }
        } catch (error) {
            Sentry.captureException(`519 Error in handleTimmer: ${error}`);
            console.log(error, "error in effect");
        }
        return () => {
            onFinish(true)
        }
    }
    const onFinish = (restrict_clear_time) => {
        clearInterval(timmerRef.current)
        setTimeInt(0)
        timeIntRef.current = 0
        if(!restrict_clear_time){
            sessionStorage.removeItem(timeStoreRef.current)
            timeStoreRef.current = null
        }
        timmerRef.current = null
        clearTimmerRunning()
    }

   const checkKey = useCallback(
     debounceMath((e) => {
       try {
         if (isNavigating) return;

         let activeElement = document.activeElement;
         let isLessonPlan = document.getElementsByClassName('lessonPlanPopUp').length > 0;
         let isDrawerOpen = document.getElementsByClassName('ant-drawer-open').length > 0;
         let isModalOpen = document.getElementsByClassName('ant-modal-mask').length > 0;
         let isRubrics = document.getElementsByClassName('rubricsPopUp').length > 0;
         let isMainBook =
           document.getElementsByClassName('main-book-popup printScreenPage').length > 0;
         let bubbleNotes = document.getElementsByClassName('disable-key-navigation').length > 0;
         let worksheetView = document.getElementsByClassName('worksheet-play-modal').length > 0;
         let disableArrow = false;

         const inputType = ['text', 'search', 'email', 'number', 'password'];
         if (
           (activeElement.tagName === 'INPUT' && inputType.includes(activeElement.type)) ||
           activeElement.tagName === 'TEXTAREA' ||
           activeElement.classList?.contains('sun-editor-editable')
         ) {
           disableArrow = true;
         }

         if (
           isDrawerOpen ||
           isLessonPlan ||
           isRubrics ||
           isModalOpen ||
           isMainBook ||
           bubbleNotes ||
           disableArrow ||
           worksheetView
         )
           return;

         e = e || window.event;

         if (e.keyCode == '37') {
           if (backBtnRef.current && !backBtnRef.current.disabled) {
             setIsNavigating(true);
             backBtnRef.current.click();
             setTimeout(() => setIsNavigating(false), 300);
           }
         } else if (e.keyCode == '39') {
           if (forwardBtnRef.current && !forwardBtnRef.current.disabled) {
             setIsNavigating(true);
             forwardBtnRef.current.click();
             setTimeout(() => setIsNavigating(false), 300);
           }
         }
       } catch (error) {
         console.log(error);
         setIsNavigating(false);
       }
     }, 150),
     [isNavigating],
   );
    const setSubmitRef = (ref) => {
        submitRef.current = ref
    }
    const preloadImage = () => {
        let cPage = parseInt(page, 10) + 1
        if (cPage + 3 > data?.content?.length) return;
        for (let i = cPage; i < cPage + 5; i++) {
            let url = getSrcPage(i)
            if (url) {
                let randoming = new Image();
                randoming.src = url
                randoming.loading ="eager"
                randoming.decode = "sync"
                randoming.fetchPriority = "high"
            }
        }
    }

      const ActiveTab = () => {
        return (
            <svg
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M6 9H12M16.5 9C16.5 13.1421 13.1421 16.5 9 16.5C4.85786 16.5 1.5 13.1421 1.5 9C1.5 4.85786 4.85786 1.5 9 1.5C13.1421 1.5 16.5 4.85786 16.5 9Z"
              stroke="#bd6fc5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        )

    }

    const InactiveTab = () => {
      return (
        <svg
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9 6V12M6 9H12M16.5 9C16.5 13.1421 13.1421 16.5 9 16.5C4.85786 16.5 1.5 13.1421 1.5 9C1.5 4.85786 4.85786 1.5 9 1.5C13.1421 1.5 16.5 4.85786 16.5 9Z"
            stroke="#975F9D"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      );
    };

    // left menu
    const RenderMenu = ({ menu, shortName }) => {
        if (!Array.isArray(menu)) {
            return null;
        }

        const pages = data?.content || [];

        const firstSubUnitIndex = menu.findIndex(
            (item) => Array.isArray(item.subUnits) && item.subUnits.length > 0,
        );
        const lastSubUnitIndex = menu.reduce(
            (lastIndex, item, i) => (Array.isArray(item.subUnits) ? i : lastIndex),
            -2,
        );
        const isNarrowScreen = window.innerWidth <= 1366;

        const handleUnitClick = (unitStart) => {
            navigate(generateUrl(unitStart));
            setEbookFlag(false);
            revokeAnswerView();
            revokeMainbookView();
            if (!isStoryViewOpen()) updatePopUpAtOnce(false);
            dispatch(updateUI({ openEngageModalTeacher: {} }));
            revokePDFView();
        };

        const handleUnitToggle = (unitId, event) => {
            event.stopPropagation();
            event.preventDefault();
            setActiveTab(unitId === activeTab ? -1 : unitId);
        };

        const handleLessonClick = (lessonStart) => {
            navigate(generateUrl(lessonStart));
            setEbookFlag(false);
            revokeAnswerView();
            revokeMainbookView();
            if (!isStoryViewOpen()) updatePopUpAtOnce(false);
            dispatch(updateUI({ openEngageModalTeacher: {} }));
            revokePDFView();
        };

        const handleLessonToggle = (lessonKey, isExpanded, event) => {
            event.stopPropagation();
            event.preventDefault();
            setExpandedLessonIndex(isExpanded ? null : lessonKey);
        };

        const handleSubLessonClick = (subLessonStart) => {
            navigate(generateUrl(subLessonStart));
            setEbookFlag(false);
            revokeAnswerView();
            revokeMainbookView();
            if (!isStoryViewOpen()) updatePopUpAtOnce(false);
            dispatch(updateUI({ openEngageModalTeacher: {} }));
            revokePDFView();
        };

        try {
            return map(menu, (x, i) => {
                const unitStart = parseInt(x.start, 10);
                const unitFinish = parseInt(x.finish, 10);
                const activeUnitEngage = getAllEngageOptionBetweenUnit(unitStart, unitFinish);
                const isUnitActive = page >= unitStart && page <= unitFinish;
                const acco = x.subUnits;
                const has_subunits = Array.isArray(acco) && acco.length > 0;
                const margin_top = firstSubUnitIndex === i ? 0 : 10;
                const displayText =
                    x.shortName.length > 15 && !isNarrowScreen
                        ? `${x.shortName.substring(0, 15)}...`
                        : x.shortName;

                if (has_subunits) {
                    return (
                        <div key={x.id + i} className="comonListGet ebookNavLeftUl">
                            <NavItem
                                className={`ebookCstmItm menu-item-drawer ebookCstmListUl ${isUnitActive ? 'ebookCstmItmActive' : ''
                                    }`}
                                active={isUnitActive}
                                onClick={() => {
                                    navigate(generateUrl(x.start));
                                    handleUnitClick(x.start);
                                }}
                                style={{
                                    flexDirection: 'row',
                                    justifyContent: 'center',
                                    marginTop: margin_top,
                                }}
                            >
                                <ItemWrapper className="ebookCstmWrap">
                                    <NavItemOverflow className="ebookCstmWrapInr">
                                        <MenuBook className="menuBookIcon" />
                                        <Tooltip title={x.shortName} placement="top">
                                            <span className="text-ellipse">{displayText}</span>
                                        </Tooltip>
                                    </NavItemOverflow>
                                    <span
                                        onClick={(e) => handleUnitToggle(x.id, e)}
                                        style={{ cursor: 'pointer' }}
                                    >
                                        {x.id === activeTab ? <ActiveTab /> : <InactiveTab />}
                                    </span>
                                </ItemWrapper>
                            </NavItem>
                            {activeUnitEngage?.length > 0 && x.id === activeTab && (
                                <EngageButton hasEngage={activeUnitEngage} forView="units" />
                            )}

                            {x.id === activeTab && (
                                <List className="ebookCstmList menu-item-drawer">
                                    {map(acco, (item, j) => {
                                        const itemStart = parseInt(item.start, 10);
                                        const itemFinish = parseInt(item.finish, 10);
                                        const isLessonActive = page >= itemStart && page <= itemFinish;
                                        const hasSubLessons =
                                            Array.isArray(item?.subLessons) && item?.subLessons?.length > 0;
                                        const lessonKey = `${x.id}-${j}`;
                                        const isLessonExpanded = expandedLessonIndex === lessonKey;
                                        const activeLessonEngage = getAllEngageOptionBetweenUnit(itemStart, itemFinish);

                                        return (
                                            <>
                                                <ListItem
                                                    active={isLessonActive}
                                                    key={item.label + j}
                                                    onClick={() => handleLessonClick(item.start)}
                                                    className={`ebookCstmLI sub-menu-drawer-list ebookCstmListUl ${isLessonActive ? 'ebookCstmLIActive' : ''
                                                        }`}
                                                >
                                                    <FundOutlined className="menuBookIcon" />
                                                    {item.label}
                                                    {hasSubLessons && (
                                                        <span
                                                            className="sub-lesson-count"
                                                            onClick={(e) => handleLessonToggle(lessonKey, isLessonExpanded, e)}
                                                            style={{ cursor: 'pointer' }}
                                                        >
                                                            {isLessonExpanded ? <ActiveTab /> : <InactiveTab />}
                                                        </span>
                                                    )}
                                                </ListItem>
                                                {activeLessonEngage?.length > 0 && hasSubLessons && isLessonExpanded && (
                                                    <EngageButton hasEngage={activeLessonEngage} forView="lesson" />
                                                )}
                                                {hasSubLessons && isLessonExpanded && item.subLessons.map((element, index) => {
                                                    const elementStart = parseInt(element.start, 10);
                                                    const elementFinish = parseInt(element.finish, 10);
                                                    const activeSubLesson =
                                                        page >= elementStart && page <= elementFinish;
                                                    const activeSubLessonEngage = getAllEngageOptionBetweenUnit(elementStart, elementFinish);

                                                    return (
                                                        <>
                                                            <ListItem
                                                                onClick={(event) => {
                                                                    event.stopPropagation();
                                                                    event.preventDefault();
                                                                    handleSubLessonClick(element.start);
                                                                }}
                                                                className={`ebookCstmLI sub-menu-drawer-list ebookCstmListUl ${activeSubLesson
                                                                        ? 'bg-00999E text-white'
                                                                        : 'bg-002b70 text-white '
                                                                    }`}
                                                                key={index}
                                                            >
                                                                <FundOutlined className="menuBookIcon" />
                                                                {element.label}
                                                            </ListItem>
                                                            {activeSubLessonEngage?.length > 0 && (
                                                                <>
                                                                    <EngageButton hasEngage={activeSubLessonEngage} forView="sub-units" />
                                                                </>

                                                            )}
                                                        </>
                                                    );
                                                })}
                                                {activeLessonEngage?.length > 0 && !hasSubLessons && !isLessonExpanded && (
                                                    <EngageButton hasEngage={activeLessonEngage} forView="lesson" />
                                                )}
                                            </>
                                        );
                                    })}
                                </List>
                            )}

                        </div>
                    );
                }

                // units without subUnits
                return (
                    <>
                        <NavItem
                            style={{ marginTop: lastSubUnitIndex + 1 === i ? 10 : 0 }}
                            key={x.id}
                            onClick={() => {
                                navigate(generateUrl(x.start));
                                setEbookFlag(false);
                                revokeAnswerView();
                                revokeMainbookView();
                                if (!isStoryViewOpen()) updatePopUpAtOnce(false);
                                revokePDFView();
                            }}
                            className={`ebookNavLi${x.id} comonListGet ebookNavLeft ${isUnitActive ? 'ebookNavActive' : ''
                                }`}
                        >
                            <MenuBook className="menuBookIcon" />
                            <NavItemOverflow>{x.shortName}</NavItemOverflow>
                        </NavItem>
                        {activeUnitEngage?.length > 0 && (
                            <>
                                <EngageButton hasEngage={activeUnitEngage} forView="units" />
                            </>

                        )}
                    </>
                );
            });

        } catch (error) {
            logToSentry(error, 'EbookLayout', 'RenderMenu');
        }
    };


    const handleCloseSuperLessonToast = () => {
        setSuperLessonAlert(false);
    }

    const handleOpenSuperLessonToast = () => {
         if(checkPopUpAtOnce()) return;
        updatePopUpAtOnce(true);
        if(UI?.openSuperLesson){
            showAlert("Super Lesson is already Opened", "error");
            return;
        }
        if(handleForDistrictAdmin()) return;
        if (isCanvasUser) {
            setOpenSuperLessonToolModal(true);
        } else {
            if (window.innerWidth >= 744) {
                if (differentiationOpen) {
                    setPopupMessage("Please close the Differentiation, to open the SuperLesson");
                    setOpen(true);
                } else if (storyCreateOpen) {
                    setPopupMessage("Please close the Story AI, to open the SuperLesson");
                    setOpen(true);
                } else {
                    setOpenSuperLessonToolModal(true);
                }
            } else {
                setPopupMessage("Super Lesson is designed for larger screens, and is not supported on smaller or mobile screens.");
                updatePopUpAtOnce(false);
                setOpen(true);
            }
        }
    }
    const handleOpenDifferentiationToast = () => {
         if(checkPopUpAtOnce()) return;
        updatePopUpAtOnce(true);
        if(UI?.openDiffModal){
            showAlert("Differnation is already Opened", "error");
            return;
        }
        if(handleForDistrictAdmin()) return;
        if (isCanvasUser) {
            setOpenDiffernationToolModal(true)
        } else {
            if (window.innerWidth >= 744) {
                if (superLessonOpen) {
                    setPopupMessage("Please close the SuperLesson, to open the Differentiation");
                    setOpen(true);
                } else if (storyCreateOpen) {
                    setPopupMessage("Please close the Story AI, to open the Differentiation");
                    setOpen(true);
                } else {
                    setOpenDiffernationToolModal(true);
                }
            } else {
                setPopupMessage("Differentiation is designed for larger screens, and is not supported on smaller or mobile screens.");
                updatePopUpAtOnce(false);
                setOpen(true);
            }
        }
    }
    const handleForDistrictAdmin = () =>{
        if (currentUser.role === 'admin') {
            setPopupMessage('Please login as teacher!');
            setOpen(true);
          return true;
        }
        return false;
      }
    const RenderMenuContent = ({ showLargeDrawer }) => {
        const items = [
            ...(data?.structures?.length > 0 ? [{
                key: 'contents',
                label: <div className='ulLitItmeList' onClick={() => showLargeDrawer()}>Contents</div>
            }] : []),
            ...(isTeacher ? [{
                key: 'instruction',
                label: <div className='ulLitItmeList' onClick={() => {
                    if(checkPopUpAtOnce()) return;
                    updatePopUpAtOnce(true);
                    setInstModal(true)
                }}>Instruction</div>
            }] : []),
            {
                key: 'vocabulary',
                label: <div className='ulLitItmeList' onClick={() => {
                    setVocModal(true)
                } }>Vocabulary</div>
            },
            // {
            //     key: 'phrases',
            //     label: <div className='ulLitItmeList' onClick={() => {
            //         //  if(checkPopUpAtOnce()) return;
            //         // updatePopUpAtOnce(true);
            //         setPhrasesModal(true)
            //     } }>Phrases</div>
            // },
            {
                key: 'cognates',
                label: <div className='ulLitItmeList' onClick={() => {
                    setCogModal(true)
                }}>Cognates</div>
            },
            ...((hasSuperLessonPage) && isTeacher ? [{
                key: 'superLesson',
                label: <div className='ulLitItmeList' onClick={handleOpenSuperLessonToast}>Super Lesson</div>
            }] : []),
            ...((hasSuperLessonPage || hasDifferentiationLessonPage) && isTeacher ? [{
                key: 'differentiation',
                label: <div className='ulLitItmeList' onClick={handleOpenDifferentiationToast}>Differentiation</div>
            }] : []),
            ...(page_articles.length > 0 && !isExam && !isStandardExam ? [{
                key: 'levels',
                label: <div className='ulLitItmeList' onClick={() => {
                    setToolsDropdown(false);
                     if(checkPopUpAtOnce()) return;
                    updatePopUpAtOnce(true);
                    setOpenArticleLevel(true)}}>Levels</div>
            }] : []),
            ...(currentUser?.role !== "student" && !isExam && !isStandardExam && page_vocab_content && !isOnlyForTeacher ? [{
                key: 'generateVocabAssignment',
                label: <div className='ulLitItmeList' onClick={() => {
                     if(checkPopUpAtOnce()) return;
                    updatePopUpAtOnce(true);
                    if(handleForDistrictAdmin()) return;
                    setassignmentAiModal(true)
                    setGenerateVocabActivity(true)
                }}>Generate Assignment from Vocab. with AI</div>
            }] : []),
            ...(currentUser?.role === "student" && checkInstructionDataForStudent ? [{
                key: 'playInstruction',
                label: <div className='ulLitItmeList' onClick={() => { 
                     if(checkPopUpAtOnce()) return;
                    updatePopUpAtOnce(true);
                    setInstModal(true)}}>Play Instruction</div>
            }] : []),
            // ...(currentUser?.role !== "student" && !isExam && Boolean(page_slide && page_slide.id) ? [{
            //     key: 'ebookPresentation',
            //     label: <div className='ulLitItmeList' onClick={() => {
            //         setToolsDropdown(false)
            //         handlerOpen(true)
            //     }}>Ebook Presentation</div>
            // }] : [])
            ...(currentUser?.role !== "student" && !isExam  && !isOnlyForTeacher && !checkStandardExamBookType && !checkApExamBookType? [{
                key: 'shareWithMe',
                label: <div className='ulLitItmeList' onClick={() => {
                     if(checkPopUpAtOnce()) return;
                    updatePopUpAtOnce(true);
                    if(handleForDistrictAdmin()) return;
                    setShareWithMe(true)
                    setToolsDropdown(false);
                }}>Shared with me</div>
            }] : []),
            ...(currentUser?.role !== "student" && !isExam  && !isOnlyForTeacher && !checkStandardExamBookType && !checkApExamBookType ? [{
                key: 'shareByMe',
                label: <div className='ulLitItmeList' onClick={() => {
                     if(checkPopUpAtOnce()) return;
                    updatePopUpAtOnce(true);
                    if(handleForDistrictAdmin()) return;
                    setShareByMe(true)
                    setToolsDropdown(false);
                }}>Shared by me</div>
            }] : []),
        ];

        return { items };
    };

    const disableBackWrad = () => {
        if (demoStatus) {
            if (demoPages) {
                const demoIndexFirstIndex = findIndex(data?.content, (p) => p.pageId == demoPages.from);
                if(demoIndexFirstIndex < 0) return false;
                return currentPageIndex <= demoIndexFirstIndex;
            }
        }
        return currentPageIndex === 0;
    }
    const disableForWard = () => {
        if (demoStatus) {
            if (demoPages) {
                const demoIndexLastIndex = findIndex(data?.content, (p) => p.pageId == demoPages.to);
                if(demoIndexLastIndex < 0) return false;
                return currentPageIndex >= demoIndexLastIndex;
            }
        }
        return currentPageIndex >= data?.content?.length - 1;
    }
    const bookmarkhandler = async () => {
        setbookmarloader(true)
        if (!bookBookmarks) {
            await dispatch(handleCreateBookmarks({
                bookId: chapter,
                page: page,
                userId: get(currentUser, "id", ""),
                classId: get(currentClass, "id", "")
            }))
        } else {
            if (bookBookmarks.page == page) {
                setbookmarloader(false)
                return;
            }
            await dispatch(handleUpdateBookmarks(bookBookmarks.id, page))
        }
        setbookmarloader(false)
    }
    const deleteBookMark = async () => {
        setDeleteBookmarloader(true)
        await dispatch(handleDeleteBookmarks(bookBookmarks.id))
        setRemoveBookMark(false)
        setDeleteBookmarloader(false)
    }
    const getImageRef = () => {
        return imageRef.current;
    }
    const goToBookmark = () => {
        navigate(generateUrl(bookBookmarks.page));
    };
    const getHyperlink = () => {
        let links = null;
        if (pageHyperlink) {
            links = pageHyperlink;
            if (ebookFlagTeacherEdition) {
                links = filter(pageHyperlink, ["type", "teacher_ed"])
            } else {
                links = null;
            }
        }
        return links;
    }

    const getPageHyperlink = () => {
        let links = null;
        if (pageHyperlink) {
            links = pageHyperlink;
            links = filter(pageHyperlink, k => k.type !== "teacher_ed")
        }
        return links;
    }

    const isTeacher = get(currentUser, "role") === "teacher";

    const dropdownRef = useRef();

    const setFlagsTeacherEdition = (flag) => {
        setEbookFlagTeacherEdition(flag);
        setEbookFlag(false);
        setStudentViewFlag(false);
    }

    // const setFlagsShowAnswer = (flag) => {
    //     setEbookFlagTeacherEdition(false);
    //     setEbookFlag(flag);
    //     setStudentViewFlag(false);
    // }
    // let existStudentView = false;
    // if (availableActivity.length || availableQuiz.length > 0) {
    //     existStudentView = true;
    // }

    const onLessonView = (val) => {
        updatePopUpAtOnce(true);
        setViewLesson(true);
        setViewLessonType(val)
    }

    const onViewShowData = (value) => {
        setViewLesson(true);
        setViewLessonTypeValue(value)
    }

    const onTwoSideChange = (page) => {
        preloadImage()
        if (typeof clearPreviewRef.current == "function") {
            clearPreviewRef.current()
        }
        navigate(generateUrl(parseInt(page, 10)));
        setFlagsFalse();
    }

    const onLessonViewDiff = (val) => {
        updatePopUpAtOnce(true);
        setViewLessonDifferentiation(true);
        setViewLessonTypeDiff(val)
    }

    const onViewShowStreamData = (val) => {
        setViewLessonDifferentiation(true);
        setViewStreamLesson(val)
    }
    const handleGenerateAiAssignment = () => {
        setToolsDropdown(false);
        if(checkPopUpAtOnce()) return;
        if (handleForDistrictAdmin()) return;
        setassignmentAiModal(true);
        setGenerateVocabActivity(false);
    }

    const getPageInfo = useCallback(() => {
        const mask_from = getNumberMask(hasSuperLessonPage?.from)
        const mask_to = getNumberMask(hasSuperLessonPage?.to)
        return mask_from && mask_to ? `(P. ${mask_from}-${mask_to})` : ''
    }, [hasSuperLessonPage])

    const getDiffernationPage = useCallback(() => {
        const mask_from = getNumberMask(hasDifferentiationLessonPage?.from)
        const mask_to = getNumberMask(hasDifferentiationLessonPage?.to)

        return mask_from && mask_to ? `(P. ${mask_from}-${mask_to})` : ''
    }, [hasDifferentiationLessonPage])

    const mediaQuery = 1579;

      const DisplaySuperLessonAndDiff = window.innerWidth < mediaQuery && currentUser?.role !== "student" 

    const show_tool =  (hasSuperLessonPage !== null) || (hasDifferentiationLessonPage !== null) || (!isExam && !isOnlyForTeacher && !isStandardExam) || Boolean(page_slide && page_slide.id);


    useEffect(() => {
        if (window.innerWidth > 769) {
          const container = document.querySelector('body');
          if (container) container.scrollTop = 0;
        }
      }, []);
      
    useEffect(() => {
        if (currentFullScreen) {
            document.documentElement.style.overflow = 'hidden';
            document.body.style.overflow = 'hidden';
        } else {
            removeNoScroll();
        }
        return () => {
            removeNoScroll();
        };
    }, [currentFullScreen, location.pathname]);
      
    useEffect( () => {
        if(isTablet){
            if(!currentFullScreen && !landscapeOrientation){
                // forceNoScroll();
           }else if(currentFullScreen && !landscapeOrientation){
                // forceNoScroll()
           }else if(!currentFullScreen && landscapeOrientation){
                removeNoScroll();
           }else{
                removeNoScroll();
           }
        }else{
            if (currentFullScreen) {
                forceNoScroll();
              } else {
                removeNoScroll();
              }
        }
       
    }, [currentFullScreen, landscapeOrientation, isTablet]);

    // Add scroll tracking for syllabus modal
    useEffect(() => {
        if (!syllabusModal || !syllabusContainerRef.current || !firstImageRef.current) return;

        const observer = new window.IntersectionObserver(
            ([entry]) => {
                setShowAnimatedArrow(entry.isIntersecting);
            },
            {
                root: syllabusContainerRef.current,
                threshold: 0.5, // At least 50% of the image should be visible
            }
        );
        observer.observe(firstImageRef.current);

        return () => {
            observer.disconnect();
        };
    }, [syllabusModal]);

    // Intersection observer for pacing guide
    useEffect(() => {
        if (!pacingModal || !pacingContainerRef.current || !firstPacingImageRef.current) return;

        const observer = new window.IntersectionObserver(
            ([entry]) => {
                setShowPacingArrow(entry.isIntersecting);
            },
            {
                root: pacingContainerRef.current,
                threshold: 0.5,
            }
        );
        observer.observe(firstPacingImageRef.current);

        return () => {
            observer.disconnect();
        };
    }, [pacingModal]);
    
    // Detect if current assignment is match-making
    // useEffect(() => {
    //     if (currentUser?.role === 'student' && activity) {
    //         // Check if we're in an assignment with match-making questions
    //         const actAct = find(chapterActivities[chapter], x => (get(x, "data.id") === activity));
    //         const actqz = find(chapterQuizzes[chapter], x => (get(x, "data.id") === quiz));
    //         const currentActivity = actAct || actqz;
    //         // const questionType = get(currentActivity, 'data.questionType');
    //         const questionType = get(currentActivity, 'data.questions[0].type');
    //         // Check submission data for activity type
    //         const submissionData = find(submissions, ['assignmentId', get(currentActivity, "activityId")]);
    //         const submissionQuestionType = get(submissionData, 'assignment.data.questionType');
    //         // Set match-making state based on question type
    //         const isMatch = questionType === 'match' || submissionQuestionType === 'match';
    //         // setIsMatchMakingAssignment(isMatch);
    //         if(isMatch){
    //             matchMakingFullScreenOpen();
    //         }else{
    //             revokeMatchMakingFullScreenClose();
    //         }
    //     } else {
    //         // setIsMatchMakingAssignment(false);
    //         revokeMatchMakingFullScreenClose();
    //     }
    // }, [currentUser, activity, quiz, chapterActivities, chapterQuizzes, chapter, submissions]);
   

    const AnimatedArrow = ({ onClick, direction }) => {
        const isUp = direction === 'up';
    
        return (
            <AnimatedArrowContainer onClick={onClick} className={`animated-arrow ${!isUp ? "up" : ""}`}>
                <AnimatedArrowBottom isAtBottom={isUp}>
                    <ArrowCircleTop />
                    <ArrowCircle className="circle-top" />
                    <ArrowCircle className="circle-main" />
                    <ArrowCircle className="circle-bottom" />
                    <ArrowCircleBottom />
                    <ArrowSvg
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                        xmlnsXlink="http://www.w3.org/1999/xlink"
                        x="0px"
                        y="0px"
                        viewBox="0 0 612 612"
                        style={{ enableBackground: "new 0 0 612 612" }}
                        xmlSpace="preserve"
                    >
                        {/* same defs and filter */}
                        <path
                            className="st-arrow"
                            d="M317.5,487.6c0.3-0.3,0.4-0.7,0.7-1.1l112.6-112.6c6.3-6.3,6.3-16.5,0-22.7c-6.3-6.3-16.5-6.3-22.7,0
                            l-86,86V136.1c0-8.9-7.3-16.2-16.2-16.2c-8.9,0-16.2,7.3-16.2,16.2v301.1l-86-86c-6.3-6.3-16.5-6.3-22.7,0
                            c-6.3,6.3-6.3,16.5,0,22.7l112.7,112.7c0.3,0.3,0.4,0.7,0.7,1c0.5,0.5,1.2,0.5,1.7,0.9c1.7,1.4,3.6,2.3,5.6,2.9
                            c0.8,0.2,1.5,0.4,2.3,0.4C308.8,492.6,313.8,491.3,317.5,487.6z"
                        />
                    </ArrowSvg>
                    <style jsx>{`
                    .animated-arrow {
                        text-align: center;
                        width: 100px;
                        height: 100px;
                        position: relative;
                        cursor: pointer;
                        filter: url("#goo");
                    }
    
                    .animated-arrow.down {
                        transform: rotate(180deg);
                    }
    
                    .arrow-body {
                        position: absolute;
                        left: 50%;
                        top: 10px;
                        animation: blob-1-anim 2s infinite ease-in-out;
                        transform: translateX(-50%);
                    }
    
                    .circle-top,
                    .circle-main,
                    .circle-bottom {
                        width: 10px;
                        height: 10px;
                        border-radius: 50%;
                        background: #ccc;
                        position: absolute;
                        left: 50%;
                    }
    
                    .circle-top {
                        top: 0;
                        animation: blob-2-anim 2s infinite ease-in-out;
                    }
    
                    .circle-main {
                        top: 20px;
                    }
    
                    .circle-bottom {
                        top: 40px;
                        animation: rotate-circle 4s linear infinite;
                    }
    
                    .arrow-svg {
                        width: 40px;
                        height: 40px;
                        position: absolute;
                        top: 60px;
                        left: 50%;
                        transform: translateX(-50%);
                        animation: scrolly 3s infinite ease-in-out;
                    }
    
                    .st-arrow {
                        fill: #000;
                    }
    
                    @keyframes blob-1-anim {
                        0% {
                            transform: translateX(-50%) translateY(0);
                        }
                        14% {
                            transform: translateX(-50%) translateY(-8px);
                        }
                        24% {
                            transform: translateX(-50%) translateY(0);
                        }
                        100% {
                            transform: translateX(-50%) translateY(0);
                        }
                    }
    
                    @keyframes blob-2-anim {
                        0%,
                        30%,
                        70% {
                            transform: scale(1) translate(-50%, 10px);
                        }
                        95% {
                            transform: scale(1) translate(-50%, 26px);
                        }
                        100% {
                            transform: scale(1) translate(-50%, 10px);
                        }
                    }
    
                    @keyframes scrolly {
                        0% {
                            transform: translate3d(0, -150%, 0) rotateX(90deg) scale(0.5)
                            skewX(3deg);
                        }
                        30%,
                        70% {
                            transform: translate3d(0, 0, 0) rotateX(0deg) scale(1) skewX(0deg);
                        }
                        95%,
                        100% {
                            transform: translate3d(0, 50%, 0) rotateX(-90deg) scale(0.5)
                            skewX(-3deg);
                        }
                    }
    
                    @keyframes rotate-circle {
                        from {
                            transform: rotate(0deg);
                        }
                        to {
                            transform: rotate(180deg);
                        }
                    }
                `}</style>
                </AnimatedArrowBottom>
            </AnimatedArrowContainer>
        );
    };
    //add debounce on navigation  for fetching handleLearningModuleCount
    const debounceHandleLearningModuleCount = useCallback(debounce((pageId) => {
        dispatch(handleLearningModuleCount({
            chapter: chapter,
            userId: currentUser?.role === 'student' ? currentClass?.teacherId : currentUser.id,
            pageId: pageId,
        }));
    }, 1000), []);

    const naviGateBackWard = () => {
        setViewLesson(false);
        setEbookFlag(false);
        revokeAiAnswerView();
        revokeAnswerView();
        revokeMainbookView();
        updatePopUpAtOnce(false);
        setViewLessonDifferentiation(false);
        setDifferentiationOpen(false);
        setSuperLessonOpen(false);
        revokePDFView();
        const pages = data?.content || [];
        const pageIndex = pages.findIndex(p => p.pageId == page);
        if (pageIndex > 0) {
            const previousPage = pages[pageIndex - 1];
            debounceHandleLearningModuleCount(previousPage.pageId);
            navigate(generateUrl(previousPage.pageId));
            if (typeof clearPreviewRef.current == "function") {
                clearPreviewRef.current()
            }
            setFlagsFalse();
            if (currentFullScreen) {
                setTimeout(forceNoScroll, 50); // <-- Enforce after navigation
            }
        }
    }
    const naviGateForwardWard = () => {
        setViewLesson(false);
        setEbookFlag(false);
        revokeAiAnswerView();
        revokeAnswerView();
        revokeMainbookView();
        updatePopUpAtOnce(false);
        setViewLessonDifferentiation(false);
        setDifferentiationOpen(false);
        setSuperLessonOpen(false);
        revokePDFView();
        const pages = data?.content || [];
        const pageIndex = pages.findIndex(p => p.pageId == page);
        if (pageIndex < pages.length - 1) {
            const nextPage = pages[pageIndex + 1];
            if(nextPage){
                debounceHandleLearningModuleCount(nextPage.pageId);
                navigate(generateUrl(nextPage.pageId));
            }
        }
        if (currentFullScreen) {
            forceNoScroll();
        }
        preloadImage()
        if (typeof clearPreviewRef.current == "function") {
            clearPreviewRef.current()
        }
        setFlagsFalse();
    }
    return (
    <SentryWrap>
        <>
            <Modal
                open={WarningPrint}
                onClose={() => setWarningPrint(false)}
            ><ModalContent>
                    Aceptar Terminos y Condiciones de el uso exclusivo de los documentos de One Way Education
                    <ModalRow>
                        <FormControlLabel control={<Checkbox checked={CheckTerms} onChange={handleCheckTerms} />} label="Acepto Terminos y Condiciones" />
                    </ModalRow>
                    <ModalRow>
                        <Button
                            color="primary"
                            variant="contained"
                            style={{ marginRight: '4px' }}
                            onClick={() => {
                                SendCheckTerms();
                            }}
                        >
                            Enviar
                        </Button>
                    </ModalRow>
                </ModalContent>
            </Modal>
            <Modal
                open={removeBookMark}
                onClose={() => setRemoveBookMark(false)}
            ><ModalContent>
                    Are you sure you want to remove all bookmarks?
                    <ModalRow>
                        <Button
                            color="primary"
                            variant="contained"
                            style={{ marginRight: '4px' }}
                            onClick={() => {
                                setRemoveBookMark(false)
                            }}
                        >
                            No
                        </Button>
                        <Button
                            color="secondary"
                            variant="contained"
                            style={{ marginRight: '4px' }}
                            onClick={() => {
                                deleteBookMark()
                            }}
                        >
                            {deleteBookmarkloader ? <Loading size={18} white /> : "Yes"}
                        </Button>
                    </ModalRow>
                </ModalContent>
            </Modal>


            <Snackbar
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                open={open}
                autoHideDuration={3000}
                onClose={handleClose}>
                <Alert severity="error">
                    <strong>ALERT:</strong> {popupMessage}
                </Alert>
            </Snackbar>
            <MainWrapper className={`${currentFullScreen && 'centered-element'} ${orientation && 'landscapePsace'}`}>
                <Wrapper className={`slideLftRghtUpr ${currentFullScreen && 'fulScrnPage'} ${is_district_admin && 'fulScrnPage'}`}>
                    <div className="ebookSlideLftRght">
                        <div className="dontShowInDesktop">
                            <Wrap className='ebokToolWrap ebokborder'>
                                {/* <FormControlLabel
                                style={{ minWidth: 85 }}
                                control={<Switch
                                    name="viewTeacherEdition"
                                    color="primary"
                                    classes={{
                                        sizeSmall: classes.sizeSmall,
                                        checked: classes.checkedSwitch
                                    }}
                                    checked={ebookFlagTeacherEdition}
                                    onChange={e => setFlagsTeacherEdition(e.target.checked)}
                                />}
                                label="TE"
                            /> */}
                                {/* {(existShowAnswer || existStudentView) && ( */}
                                {/* <FormControlLabel
                                    style={{ minWidth: 125 }}
    
                                    control={<Switch
                                        color="primary"
                                        classes={{
                                            sizeSmall: classes.sizeSmall,
                                            checked: classes.checkedSwitch
                                        }}
                                        // checked={ebookFlag}
                                        // onChange={e => setFlagsShowAnswer(e.target.checked)}
                                    />}
                                    label="Answers"
                                /> */}
                                {/* )} */}
                                {/* <FormControlLabel
                                style={{ minWidth: 80 }}
                                control={<Switch
                                    color="primary"
                                    classes={{
                                        sizeSmall: classes.sizeSmall,
                                        checked: classes.checkedSwitch
                                    }}
                                    checked={learnPlanModal}
                                    onChange={e => setLearnPlanModal(e.target.checked)}
                                />}
                                label="LP"
                            /> */}

                                {/* <FormControlLabel
                            classes={{
                                root: classes.root,
                                label: classes.label,
                                }}
                                style={{ width: 120 }}
                            control={
                                <Switch
                                    classes={{
                                        sizeSmall: classes.sizeSmall,
                                        checked: classes.checkedSwitch
                                    }}
                                    // checked={ebookFlagTeacherEdition}
                                    // onChange={e => setFlagsTeacherEdition(e.target.checked)}
                                    name="viewTeacherEdition"
                                    color="primary"
                                    size="small"
                                />
                            }
                                label="Answers"
                        /> */}
                                {/* <FormControlLabel
                            classes={{
                                root: classes.root,
                                label: classes.label,
                            }}
                            control={
                                <Switch
                                    classes={{
                                        sizeSmall: classes.sizeSmall,
                                        checked: classes.checkedSwitch
                                    }}
                                    // checked={ebookFlagTeacherEdition}
                                    // onChange={e => setFlagsTeacherEdition(e.target.checked)}
                                    name="viewTeacherEdition"
                                    color="primary"
                                    size="small"
                                />
                            }
                            label="LP"
                        /> */}
                            </Wrap>
                        </div>
                       
                    </div>
                    
                    <div className="arowEbok">
                        <ButtonContainer
                            ref={backBtnRef}
                            disabled={disableBackWrad()}
                            onClick={naviGateBackWard}
                            left={12}
                            mobileLeft={0}
                            tabletLeft={0}
                            className="cstmLeftArow">
                            <LeftCircleOutlined style={{ fontSize: '52px', color: "#020A52", background: 'rgba(255, 255, 255, 0.7)', borderRadius: 30 }} />
                        </ButtonContainer>
                        <ButtonContainer
                            ref={forwardBtnRef}
                            disabled={disableForWard()}
                            onClick={naviGateForwardWard}
                            right={12}
                            mobileRight={0}
                            tabletRight={0}
                            className="cstmRghtArow">
                            <RightCircleOutlined style={{ fontSize: '52px', color: "#020A52", background: 'rgba(255, 255, 255, 0.7)', borderRadius: 30 }} />
                        </ButtonContainer>
                    </div>

                    <div style={{ marginTop: currentFullScreen && landscapeOrientation ? 45 : 'unset', width:'100%' }}>
                    <Container style={{ padding: "0", marginTop: currentFullScreen && !landscapeOrientation ? -50 : 'unset' }} className="eBookTabLftUpr">
                            <NavContainer style={{ display: isDrawerOpen ? 'none' : '' }} className={`111 eBookTabWeb ${data?.structures?.length === 0 ? "ebokLeftTabCstmNoData" : "ebokLeftTabCstm"}`}>
                                {isTeacher && location?.pathname === "/ebook" && (
                                    pacingTeacher?.length > 0 && (
                                        <PacingButton 
                                          className={activeTab === "pacing" ? "pacingButtonActv" : ""}
                                          onClick={() => {
                                            if(checkPopUpAtOnce()) return;
                                            updatePopUpAtOnce(true);
                                            if (!pacingTeacher || pacingTeacher?.length === 0) {
                                                setPopupMessage('No Images were found in this book.')
                                                setOpen(true);
                                            } else {
                                                setActiveTab("pacing");
                                                setPacingModal(true);
                                                setSyllabusModal(false);
                                            }
                                        }}>
                                            Pacing Guide
                                        </PacingButton>
                                    
                                    )
                                )}
                                {isTeacher && location?.pathname === "/ebook" &&(
                                    syllabusTeacher?.length > 0 && (
                                    <PacingButton 
                                      className={activeTab === "syllabus" ? "pacingButtonActv" : ""}
                                      onClick={() => {
                                        if(checkPopUpAtOnce()) return;
                                        updatePopUpAtOnce(true);
                                        if (!syllabusTeacher || syllabusTeacher.length === 0) {
                                            setPopupMessage('No Images were found in this book.')
                                            setOpen(true);
                                        }
                                        else {
                                            setActiveTab("syllabus");
                                            setSyllabusModal(true);
                                            setPacingModal(false);
                                        }
                                    }}>
                                    Syllabus
                                    </PacingButton>
                                    )
                                )}
                               {<RenderMenu menu={data?.structures} />}
                            </NavContainer>
                            
                        <ImageContainer isDrawerOpen={isMatchMakingAssignment && isDrawerOpen} className={`${showWidgetZIndex ? 'setWidgetIndex' : ''} ${currentFullScreen && 'largTab'}`} style={currentFullScreen && !landscapeOrientation ? { transform: "scale(0.8)" } : {}} onContextMenu={(e) => {
                            e.preventDefault();
                            showCopyRight()
                        }}>
                            {/* <Row style={{ marginTop: -30 }} className='playInsRw'> */}
                            <Row className='addInsRwAddOnUpr 111'>
                                
                                <Col span={21} className='addInsRw addInsRwAddOn' style={{ display: "flex", flexDirection: "row", alignItems: "end" }}>
                                    {isApExams ? (
                                        <BackButton
                                            className='text-wrap min-w-50px'
                                            style={{ marginRight: "1.5px", whiteSpace: "nowrap", display: "flex", alignItems: "center", padding: "7px 8px" }}
                                            onClick={() => navigate(`/ap?id=69`)}
                                        >
                                            <ArrowBack style={{ fontSize: '14px', marginRight: '4px' }} />
                                            <BackText>Back to Ap</BackText>
                                            <ShortBackText>Back</ShortBackText>
                                        </BackButton>
                                        ) : null}

                                    {currentUser?.role == 'admin' ?
                                      <div className='ebookBackArow'>
                                        <BackButtonEbook onClick={() => navigate('/ebook_list?key=informate')} style={{ borderTopLeftRadius: 0, borderTopRightRadius: 0, minWidth: 100 }} />
                                      </div> : null
                                    }    

                                    {/* {is_district_admin ? <BackButton className='text-wrap min-w-50px' style={{ marginRight: "1.5px", whiteSpace: "nowrap", display: "flex", alignItems: "center", padding: "7px 8px" }} onClick={() => history.push('/ebook_list')}>
                                        <ArrowBack style={{ fontSize: '14px', marginRight: '4px' }} />
                                        Back
                                    </BackButton> : null} */}

                                    <MobileBar className="mobileTabs eBookTabLft eBookTabMob scheduledWebHide">
                                        <MobileMenu className="mobileTabDrop">
                                            <Dropdown menu={RenderMenuContent({showLargeDrawer})} trigger={['click']}>
                                                <Button style={{ display: 'flex', alignItems: 'center' }} className="BtnMenuOptions">
                                                    <MenuOutlined />
                                                </Button>
                                            </Dropdown>
                                        </MobileMenu>
                                    </MobileBar>
                                    <MobileBar className="mobileTabs eBookTabLft eBookTabMob scheduledWeb">
                                        <MobileMenu className="mobileTabDrop">
                                            {/* <Dropdown> */}
                                            {data?.structures?.length > 0 ? <ButtonLink onClick={() => showLargeDrawer()} style={{ borderRight: 8, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 16, height: 36 }}>
                                                {/* <MenuOutlined /> */}
                                                Contents <KeyboardArrowDown />
                                            </ButtonLink> : null}
                                           
                                            {/* </Dropdown> */}
                                        </MobileMenu>
                                    </MobileBar>
                                    <Instructions pageId={page} bookId={chapter} instModal={instModal} setInstModal={setInstModal} setCheckInstructionDataForStudent={(value)=>setCheckInstructionDataForStudent(value)} closeToolsDropdown={() => setToolsDropdown(false)} />
                                    {is_non_spanish 
                                    ? <VocabilaryForNonSpanish  isOnlyForTeacher={isOnlyForTeacher} isCheckingOpen={vocModal}  vocabilaryButtonClassName='ebook-vocab-book' pageId={page} bookId={chapter} setVocModal={setVocModal} closeToolsDropdown={() => setToolsDropdown(false)} /> 
                                    : <Vocabilary vocabilaryButtonClassName='ebook-vocab-book' pageId={page} bookId={chapter} isCheckingOpen={vocModal} setVocModal={setVocModal} isOnlyForTeacher={isOnlyForTeacher} closeToolsDropdown={() => setToolsDropdown(false)} />
                                    }
                                    {/* <div className={currentUser?.role === "student" ? "ml-5px" : ""}>
                                    {is_non_spanish 
                                    ? <PhrasesForNonSpanish isOnlyForTeacher={isOnlyForTeacher} isCheckingOpen={phrasesModal} phrasesButtonClassName='ebook-vocab-book' pageId={page} bookId={chapter} setVocModal={setPhrasesModal} /> 
                                    : <Phrases isOnlyForTeacher={isOnlyForTeacher} isCheckingOpen={phrasesModal} vocabilaryButtonClassName='ebook-vocab-book' pageId={page} bookId={chapter} setVocModal={setPhrasesModal} />
                                    }
                                    </div> */}
                                    <div className={currentUser?.role === "student" ? "ml-5px" : ""}>
                                        <CognatesHandler non_spanish_vocab={is_non_spanish} vocabilaryButtonClassName='ebook-vocab-book' pageId={page} bookId={chapter} isCheckingOpen={cogModal} setVocModal={setCogModal} isOnlyForTeacher={isOnlyForTeacher} closeToolsDropdown={() => setToolsDropdown(false)} />
                                    </div>
                                    


                                    <div style={{ position: "relative" }} className='relative '
                                        // onMouseLeave={() => setToolsDropdown(false)}
                                    >
                                        {currentUser?.role !== "student" && show_tool && !isExam && !isStandardExam && (
                                            <Button
                                            onClick={() => {
                                                if(checkPopUpAtOnce()) {
                                                    return;
                                                }
                                                setToolsDropdown(true)
                                            }}
                                            // onMouseEnter={() => setToolsDropdown(true)}
                                                style={{ minWidth: "unset", height: "36px", borderRadius: "0px !important"
                                                    // , display: checkSuperLessonAndDiff ? "block !important" : "none" 
                                                }}
                                                className="vocabularyBtnDiff toolButton-new"
                                            >
                                                Tools
                                            </Button>
                                        )}
                                        {page_articles.length>0 && (
                                            <Button
                                                onClick={() => {
                                                    setToolsDropdown(false);
                                                    if(checkPopUpAtOnce()) {
                                                    return;
                                                }
                                                setOpenArticleLevel(true)
                                                updatePopUpAtOnce(true);
                                                }}
                                                style={{ minWidth: "unset", height: "36px", borderRadius: "0px !important" }}
                                                className="vocabularyBtnDiff toolButton-new"
                                            >
                                                Levels
                                            </Button>
                                        )}
                                        {toolsDropdown && (
                                            <ClickOutside
                                                className="dropdown-tooling-ebook"
                                                onClickOutside={() => setToolsDropdown(false)}
                                            >
                                                <DropdownWrapper>
                                                    {hasSuperLessonPage && currentUser?.role !== "student" && (
                                                        <DropdownItem style={{backgroundColor: UI?.openSuperLesson ? "lightGrey" : ""}}  onClick={handleOpenSuperLessonToast}>
                                                            Super Lesson {getPageInfo()}
                                                        </DropdownItem>
                                                    )}

                                                    {(hasSuperLessonPage || hasDifferentiationLessonPage) && currentUser?.role !== "student" && (
                                                        <DropdownItem style={{backgroundColor: UI?.openDiffModal ? "lightGrey" : ""}}  onClick={handleOpenDifferentiationToast}>
                                                            Differentiation {getDiffernationPage()}
                                                        </DropdownItem>
                                                    )}

                                                    {/* {currentUser?.role !== "student" && !isExam && !isOnlyForTeacher && !is_non_roman && (
                                                        <DropdownItem
                                                            onClick={() => {
                                                                if (handleForDistrictAdmin()) return;
                                                                setassignmentAiModal(true);
                                                                setGenerateVocabActivity(false);
                                                            }}
                                                        >
                                                            Generate Assignment with AI
                                                        </DropdownItem>
                                                    )} */}

                                                    {/* {currentUser?.role !== "student" && !isExam && !isOnlyForTeacher && (
                                                        <DropdownItem
                                                         onClick={() => {
                                                            if (handleForDistrictAdmin()) return;
                                                            setIsOpen(true);
                                                            setToolsDropdown(false);
                                                        }} className='differnation-tool Grammar-Drills'>Generate Grammar Drills</DropdownItem>
                                                    )} */}

                                                    {currentUser?.role !== "student" && !isExam && !isOnlyForTeacher && page_vocab_content && (
                                                        <>
                                                        <DropdownItem
                                                            onClick={() => {
                                                                if(checkPopUpAtOnce()) {
                                                                    return;
                                                                }
                                                                if (handleForDistrictAdmin()) return;
                                                                setassignmentAiModal(true);
                                                                setGenerateVocabActivity(true);
                                                            }}
                                                        >
                                                            Generate Assignment from vocab. with AI
                                                        </DropdownItem>

                                                        </>
                                                    )}

                                                    
                                                    {/* {slideWidget} */}
                                                    {/* {currentUser?.role !== "student" && !isExam && !isOnlyForTeacher && Boolean(page_slide && page_slide.id) && (
                                                        <DropdownItem
                                                            // onClick={() => {
                                                                // if (handleForDistrictAdmin()) return;
                                                                // setassignmentAiModal(true);
                                                                // setGenerateVocabActivity(true);
                                                            // }}
                                                            onClick={() => {
                                                                setToolsDropdown(false)
                                                                handlerOpen(true);
                                                            }}
                                                        >
                                                            Ebook Presentation
                                                        </DropdownItem>
                                                    )} */}
                                                    
                                                    {/* Show message when no tools are available */}
                                                    {!(
                                                        (hasSuperLessonPage && currentUser?.role !== "student") ||
                                                        (hasDifferentiationLessonPage && currentUser?.role !== "student") ||
                                                        (currentUser?.role !== "student" && !isExam && !isOnlyForTeacher && page_vocab_content)
                                                    ) && (
                                                        // <div className="no-tool-message">
                                                        //   No tools are available22
                                                        // </div>
                                                        <>
                                                        </>
                                                    )}
                                                    {currentUser?.role !== "student" && !isExam && !checkApExamBookType && !checkStandardExamBookType && (
                                                        <DropdownItem
                                                            onClick={() => {
                                                                if(checkPopUpAtOnce()) {
                                                                    return;
                                                                }
                                                                setShareWithMe(true);
                                                                setToolsDropdown(false);
                                                            }}
                                                        >
                                                                Shared with me
                                                        </DropdownItem>
                                                    )}

                                                    {currentUser?.role !== "student" && !isExam && !checkApExamBookType && !checkStandardExamBookType && (
                                                            <DropdownItem
                                                            onClick={() => {
                                                                if(checkPopUpAtOnce()) {
                                                                    return;
                                                                }
                                                                setShareByMe(true);
                                                                setToolsDropdown(false);
                                                            }}
                                                        >
                                                            Shared by me
                                                        </DropdownItem>
                                                    )}

                                                </DropdownWrapper>
                                            </ClickOutside>
                                        )
                                        
                                        }

                                      
                                    </div>
                                    {hasSuperLessonPage && currentUser?.role !== "student" && (
                                        <SuperLessons
                                            showModal={hasSuperLessonPage && currentUser?.role !== "student"}
                                            viewLesson={viewLesson}
                                            superLessonData={hasSuperLessonPage}
                                            bookId={chapter}
                                            pageId={page}
                                            setVocModal={setVocModal}
                                            onLessonOpen={onLessonView}
                                            onSuperLessonOpen={(value) => {
                                                setSuperLessonOpen(value);
                                            }}
                                            onViewShowData={onViewShowData}
                                            data={data}
                                            differentiationOpen={differentiationOpen}
                                            from={'ebook'}
                                            openSuperLessonToolModal={openSuperLessonToolModal}
                                            setToolsDropdown={setToolsDropdown}
                                            setOpenSuperLessonToolModal={setOpenSuperLessonToolModal}
                                            mediaQuery={mediaQuery}
                                            DisplaySuperLessonAndDiff={DisplaySuperLessonAndDiff}
                                            superLessonConfig={{
                                                from: hasSuperLessonPage?.from,
                                                to: hasSuperLessonPage?.to
                                            }}
                                        />
                                    )}
                                    {(hasSuperLessonPage || hasDifferentiationLessonPage) && currentUser?.role !== "student" && (
                                        <Differentiation
                                            showModal={(hasSuperLessonPage || hasDifferentiationLessonPage) && currentUser?.role !== "student"}
                                            viewLesson={viewLessonDifferentiation}
                                            superLessonData={hasDifferentiationLessonPage || hasSuperLessonPage}
                                            bookId={chapter}
                                            pageId={page}
                                            setVocModal={setVocModal}
                                            onLessonOpen={onLessonViewDiff}
                                            data={data}
                                            superLessonOpen={superLessonOpen}
                                            onViewShowData={onViewShowStreamData}
                                            setViewStreamLesson={setViewStreamLesson}
                                            setIsStream={setIsStream}
                                            viewStreamLesson={viewStreamLesson}
                                            onDifferentiationOpen={(value) => {
                                                setDifferentiationOpen(value);
                                            }}
                                            from={'ebook'}
                                            openDiffernationToolModal={openDiffernationToolModal}
                                            setToolsDropdown={setToolsDropdown}
                                            mediaQuery={mediaQuery}
                                            setOpenDiffernationToolModal={setOpenDiffernationToolModal}
                                            DisplaySuperLessonAndDiff={DisplaySuperLessonAndDiff}
                                        />
                                    )}
                                    <AssignmentAiSection 
                                        data={data} 
                                        assignmentAiModal={assignmentAiModal} 
                                        setassignmentAiModal={setassignmentAiModal}
                                        generateVocabActivity={generateVocabActivity}
                                        setGenerateVocabActivity={setGenerateVocabActivity}
                                        page={page}
                                        chapter={chapter}
                                        pageSrc={getSrcPage(page)}
                                        BALCON_PAGES={[]}
                                    />
                                    <SuperLessonDiffList 
                                        shareWithMe={shareWithMe}
                                        setShareWithMe={setShareWithMe}
                                        shareByMe={shareByMe}
                                        setShareByMe={setShareByMe} 
                                        chapter={chapter}
                                        from={'ebook'}
                                    />
                                </Col>
                                <Col span={3} className='addInsRw' style={{ alignItems: "flex-end", justifyContent: "flex-end", display: "flex", flexDirection: "row" }}>
                                    <ViewGallery pages={data?.content} />
                                    <TwoSidePages pageId={page} getAllPages={data?.content} onTwoSideChange={(val) => onTwoSideChange(val)} onTwoSideButtonClick={() => preloadImage()} />
                                    <BookMarkWrapper>
                                        {isTeacher && <BookmarkLinkWrapper> <AddBookmarkButton
                                            className='addBookMarkIcon'
                                            color="primary"
                                            variant="contained"
                                            style={{
                                                marginRight: bookBookmarks ? '4px' : 0, borderTopRightRadius: "8px", borderTopLeftRadius: "8px", marginLeft: "1.5px"
                                            }}
                                            onClick={() => {
                                                bookmarkhandler()
                                            }}
                                        >
                                            {bookmarkloader ? <Loading size={20} white /> : <Bookmark color={get(bookBookmarks, "page", '') == page ? "secondary" : "action"} />}
                                        </AddBookmarkButton></BookmarkLinkWrapper>}
                                        {bookBookmarks ? (<BookmarkLinkWrapper>
                                            <MarkButton onClick={() => {
                                                goToBookmark()
                                            }}>
                                                Pg:{getNumberMask(chapter, get(bookBookmarks, "page", ''), booksAllList)}
                                            </MarkButton>
                                            {isTeacher && <TrashButton
                                                className='addTrashIcon'
                                                onClick={() => {
                                                    setRemoveBookMark(true)
                                                }}
                                            >
                                                <Delete color='secondary' />
                                            </TrashButton>}
                                        </BookmarkLinkWrapper>) : null}
                                    </BookMarkWrapper>
                                    {isTablet ? 
                                    <FullScreenBtn
                                            className='fullScrenAddOn'
                                            onClick={currentFullScreen ? ExitFullScreenMode : FullScreenMode}
                                            style={{
                                                minWidth: "unset", height: "36px", borderRadius: "0px !important"
                                            }}
                                        >
                                        {!currentFullScreen ? <Fullscreen style={{ color: 'white' }} /> : <FullscreenExit style={{ color: 'white' }} />}
                                    </FullScreenBtn>
                                    : null }
                                   
                                    {!orientation && currentFullScreen && <ActivityBtn
                                        onClick={toggleDrawer}
                                        style={{
                                            minWidth: "unset", height: "36px", borderRadius: "0px !important"
                                        }}
                                    >
                                        Activity
                                    </ActivityBtn>}
                                </Col>
                            </Row>
                            <EbookGallleryView getRef={getImageRef} onPageSelect={ind => navigate(generateUrl(ind))} />

                            <div ref={imageRef}
                                className='to_be_print setCstmPosition'
                                style={{ zIndex: 0 }}
                            >
                                {/* {currentUser?.role === "student" && isMatchMakingAssignment && <button className="setCstmPositionBtn" onClick={toggleDrawer}>
                                    {isDrawerOpen ? 
                                        <ChevronRight style={{ color: 'white', fontSize: '20px' }} /> : 
                                        <ChevronLeft style={{ color: 'white', fontSize: '20px' }} />
                                    }
                                </button>} */}

                                {hasSuperLessonPage && currentUser?.role !== "student" &&
                                    <LessonViewModal
                                        pageId={page}
                                        bookId={chapter}
                                        superLessonData={hasSuperLessonPage}
                                        showModal={hasSuperLessonPage && currentUser?.role !== "student"}
                                        open={viewLesson}
                                        viewLessonTypeValue={viewLessonTypeValue}
                                        viewLessonType={viewLessonType}
                                        onClose={async () => {
                                            updatePopUpAtOnce(false)
                                            setViewLesson(false)
                                            setSuperLessonOpen(false)
                                            await dispatch(updateUI({openSuperLesson: false}))
                                        }} data={data}
                                        from={'ebook'}
                                        isCanvasUser={isCanvasUser}
                                        setViewLessonTypeValue={setViewLessonTypeValue}
                                        superLessonConfig={{
                                            from: hasSuperLessonPage?.from,
                                            to: hasSuperLessonPage?.to
                                        }}
                                    />
                                }
                                {openStoryWithAi && !storyView?.open &&
                                    <StoryViewModal
                                        imageConfiguration={imageConfiguration}
                                        open={openStoryWithAiView}
                                        setOpenStoryWithAiView={setOpenStoryWithAiView}
                                        viewLessonType={viewLessonType}
                                        onClose={() => {
                                            updatePopUpAtOnce(false);
                                            setOpenStoryWithAi(false);
                                            setOpenStoryWithAiView(false);
                                            setStoryCreateOpen(false);
                                            
                                            if (UI?.soyHistoriasView?.isNotification) {
                                                dispatch(updateUI({
                                                    soyHistoriasView: {
                                                        open: false,
                                                        data: null,
                                                        isNotification: false
                                                    }
                                                }));
                                            }
                                        }} 
                                        onMoreStory={() => {
                                            setOpenStoryWithAi(false);
                                            setOpenStoryWithAiView(false);
                                            handleOpenStoryWithAi('more_story');
                                            setStoryCreateOpen(true);
                                        }}
                                        isCanvasUser={isCanvasUser}
                                        hasStoryWithAi={hasStoryWithAi}
                                        handleStoryId={handleStoryId}
                                        setHandleStoryStream={setHandleStoryStream}
                                        handleStoryStream={handleStoryStream}
                                        setHandleStoryStreamTitle={setHandleStoryStreamTitle}
                                        handleStoryStreamTitle={handleStoryStreamTitle}
                                        from={'ebook'}
                                        soyHistoria={currentUser?.role === "student" && Array.isArray(hasStoryWithAi) && hasStoryWithAi.length > 0}
                                    />
                                }
                                {openArticleLevel?
                                    <ViewArticleLevels
                                      imageConfiguration={imageConfiguration}
                                      open={openArticleLevel}
                                      onClose={() => {
                                          updatePopUpAtOnce(false);
                                          setOpenArticleLevel(false)
                                      }}
                                      viewLessonType={viewLessonType}
                                      setOpenArticleModalView={setOpenArticleLevel}
                                      chapter={chapter}
                                      page={page}
                                      page_articles={page_articles}
                                    />
                                :null}
                                {
                                    (hasSuperLessonPage || hasDifferentiationLessonPage) && currentUser?.role !== "student" &&
                                    <DifferentiationViewModal
                                        pageId={page}
                                        bookId={chapter}
                                        superLessonData={hasDifferentiationLessonPage}
                                        showModal={hasDifferentiationLessonPage && currentUser?.role !== "student"}
                                        open={viewLessonDifferentiation}
                                        viewLessonType={viewLessonTypeDiff}
                                        viewStreamLesson={viewStreamLesson}
                                        setViewStreamLesson={setViewStreamLesson}
                                        isStream={isStream}
                                        onClose={async () => {
                                            updatePopUpAtOnce(false)
                                            setViewStreamLesson('');
                                            setViewLessonDifferentiation(false)
                                            setDifferentiationOpen(false)
                                            await dispatch(updateUI({openDiffModal: false}));
                                           
                                        }}
                                        data={data}
                                        from={'ebook'}
                                        isCanvasUser={isCanvasUser}
                                        superLessonConfig={{
                                            from: hasSuperLessonPage?.from,
                                            to: hasSuperLessonPage?.to
                                        }}
                                    />
                                }
                              
                                        <SentenceStarterPopUp 
                                            bookId={chapter}
                                            pageId={page}  
                                            currentUser={currentUser} 
                                            book={book}
                                        />
                            
                                   
                                <MainbookPopup getRef={getImageRef} />
                                <ShowBookPreviewExtensionActivity getRef={getImageRef} />
                                <AnswerPopup getRef={getImageRef} onClose={() => {
                                    setEbookFlag(false)
                                    setEbookFlagTeacherEdition(false);
                                }} />
                                <PDFPopup getRef={getImageRef} onClose={() => {
                                    revokePDFView();
                                }} />
                                <ActivityStandardsPopup getRef={getImageRef} onClose={() => {
                                }} />
                                <StoryAIPopup imageConfiguration={imageConfiguration} getRef={getImageRef} onClose={() => {
                                    // setEbookFlag(false)
                                }} />
                                <ImageHighlighter imageUrl={getSrcPage(page)} userId={currentUser.id} pageId={page} bookId={chapter} setImageConfiguration={setImageConfiguration} imageConfiguration={imageConfiguration} isNonNative={book?.book_type === 'non_native_spanish' || false} />

                                <SentenceStarterBookPopUp getRef={getImageRef} />
                                {/* <Images src={getSrcPage(page)} /> */}
                            </div>
                            <AssignableNotificationAnswer getRef={getImageRef} />
                            {showStoryModal && (
                                <CreateStoryModal
                                    data={data}
                                    open={showStoryModal}
                                    onClose={() => {
                                        updatePopUpAtOnce(false);
                                        setShowStoryModal(false);
                                        setStoryCreateOpen(false);
                                    }}
                                    storyData={hasStoryWithAi}
                                    onShowView={(id) => {
                                        setHandleStoryId(id);
                                        setOpenStoryWithAi(true);
                                        setOpenStoryWithAiView(true);
                                    }}
                                    onShowStreamView={(val) => {
                                        setHandleStoryStream(val);
                                        setOpenStoryWithAi(true);
                                        setOpenStoryWithAiView(true);
                                    }}
                                    onStoryTitle={(title) => {
                                        setHandleStoryStreamTitle(title);
                                        setOpenStoryWithAi(true);
                                        setOpenStoryWithAiView(true);
                                    }}
                                    from={'ebook'}
                                    isCanvasUser={isCanvasUser}
                                    page={page}
                                    chapter={chapter}
                                    imageConfiguration={imageConfiguration}
                                />
                                )}
                                {UI?.openEngageModalTeacher?.open && (
                                    <EngageView onClose={() => {
                                        updatePopUpAtOnce(false);
                                        dispatch(updateUI({openEngageModalTeacher: {}}));
                                    }} data={UI?.openEngageModalTeacher?.data} open={UI?.openEngageModalTeacher?.open} showPacingArrow={true} />
                                )}

                                {pacingModal && (
                                    <PackingContainer>
                                        <IconButton onClick={() => {setPacingModal(false); updatePopUpAtOnce(false); }} style={{ position: "absolute", top: "-22px", right: "-20px" }}>
                                            <CloseCircleFilled style={{color:"red", backgroundColor: "white", borderRadius: "50%"}} />
                                        </IconButton>

                                        <VerticalScrollContainer ref={pacingContainerRef}>
                                            {pacingTeacher.length > 0 && showPacingArrow && (
                                             <div className='animateArowCstm'>
                                                <AnimatedArrowWrapper><AnimatedArrow direction="down" /></AnimatedArrowWrapper>
                                             </div>
                                            )}

                                            {pacingTeacher?.map((src, index) => (
                                              <ImageItem key={index} src={src?.resource} alt={`Image ${index + 1}`} ref={index === 0 ? firstPacingImageRef : null} />
                                            ))}
                                        </VerticalScrollContainer>
                                       </PackingContainer>
                                )}
                                {syllabusModal && (
                                    <PackingContainer>
                                        <IconButton onClick={() => {setSyllabusModal(false);  updatePopUpAtOnce(false);}} style={{ position: "absolute", top: "-22px", right: "-20px" }}>
                                            <CloseCircleFilled style={{color:"red", backgroundColor: "white", borderRadius: "50%"}} />
                                        </IconButton>
                                        <VerticalScrollContainer ref={syllabusContainerRef}>

                                        {syllabusTeacher.length > 0 && showAnimatedArrow && (
                                          <div className='animateArowCstm'>
                                            <AnimatedArrowWrapper><AnimatedArrow direction="down" /></AnimatedArrowWrapper>
                                          </div>
                                        )}
                                        
                                            {syllabusTeacher?.map((src, index) => (
                                               <> 
                                                <ImageItem key={index} src={src?.resource} alt={`Image ${index + 1}`} ref={index === 0 ? firstImageRef : null} />
                                               </> 
                                            ))}
                                        </VerticalScrollContainer>
                                    </PackingContainer>
                                )}
                        </ImageContainer>

                        {/* Right Section */}
                        <ToolsContainer
                            isDrawerOpen={isMatchMakingAssignment && isDrawerOpen}
                        className={`${showNotesZIndex ? 'setIndxNotes' : ''} ${!orientation ? (currentFullScreen ? 'sidebar' : '') : ''} ${isDrawerOpen ? ' open setFullMatchMake' : ''
                                } ${isTabletDevice ? 'tablet-device' : ''}`}
                            style={currentFullScreen && orientation ? {} :{}}
                        >
                            <EbookTooling
                                isMatchMakingAssignment={isMatchMakingAssignment}
                                setIsMatchMakingAssignment={setIsMatchMakingAssignment}
                                toggleDrawer={toggleDrawer}
                                isDrawerOpen={isDrawerOpen}
                                classUsers={classUsers}
                                activity={activity}
                                chapter={chapter}
                                history={navigate}
                                limit={data?.content.length}
                                page={page}
                                quiz={quiz}
                                data={data}
                                showCopyRight={showCopyRight}
                                tips={page_tips}
                                existTeacherEdition={existTeacherEdition}
                                existShowAnswer={existShowAnswer}
                                existAssignmentLink={existAssignmentLink}
                                ebookFlag={ebookFlag}
                                setEbookFlag={setEbookFlag}
                                ebookFlagTeacherEdition={ebookFlagTeacherEdition}
                                setEbookFlagTeacherEdition={setEbookFlagTeacherEdition}
                                showSpecialSupport={showSpecialSupport}
                                setShowSpecialSupport={setShowSpecialSupport}
                                studentViewFlag={studentViewFlag}
                                setStudentViewFlag={setStudentViewFlag}
                                handleImagePrint={handleImagePrint}
                                printLoader={printLoader}
                                setSubmitRef={setSubmitRef}
                                timeInt={timeInt}
                                timmer={timeIntRef.current}
                                onFinish={onFinish}
                                onPageChage={re => clearPreviewRef.current = re}
                                lessonPlan={lessonPlan}
                                rubrics={rubrics}
                                assignmentPlan={assignmentPlan}
                                booksAllList={booksAllList}
                                pageSrc={getSrcPage(page)}
                                book={book}
                                links={getHyperlink()}
                                pageHyperlink={getPageHyperlink()}
                                learnPlanModals={learnPlanModal}
                                setLearnPlanModals={setLearnPlanModal}
                                workbook_plan={workbook_plan}
                                main_book={main_book}
                                dataBook={dataBook}
                                oneGameModal={() => setAiModals(true)}
                                oneStudyModal={() => setStudyModals(true)}
                                aiModals={aiModals}
                                setAiModals={setAiModals}
                                page_1game_ai_content={page_1game_ai_content}
                                examBookIds={examBookIds}
                                imageConfiguration={imageConfiguration}
                                isExam={isExam}
                                sentenceStarterData={sentenceStarterData}
                                handleOpenStoryWithAi={handleOpenStoryWithAi}
                                hasStoryWithAi={hasStoryWithAi}
                                handlerOpenPresentation={handlerOpen}
                                page_slide={page_slide}
                                handleGenerateAiAssignment={handleGenerateAiAssignment}
                                is_non_roman={is_non_roman}
                                isStandardExam={isStandardExam}
                                setToolsDropdown={setToolsDropdown}
                            />
                        </ToolsContainer>

                    </Container>
                    </div>

                </Wrapper>
            </MainWrapper>
            <Drawer
                className='unitListDrawer'
                onClose={onClose}
                open={opens}
            >
                <div style={{ backgroundColor: 'rgb(2, 10, 82)', padding: '10px 5px' }}>
                    <span className='all-units-fonts' style={{ fontSize: 16, fontWeight: 600, color: 'white', marginLeft: 10, marginTop: 10 }}>All Units</span>
                </div>
                <MobileContainer>
                {isTeacher && (
                    pacingTeacher?.length > 0 && (
                        <PacingButton className='pacingItemMob' onClick={() => {
                            if(checkPopUpAtOnce()) {
                                return;
                            }
                            updatePopUpAtOnce(true);
                            if (!pacingTeacher || pacingTeacher?.length === 0) {
                                setPopupMessage('No Images were found in this book.')
                                setOpen(true);
                            } else {
                                setPacingModal(true);
                                setSyllabusModal(false);
                            }
                        }}>
                            Pacing Guide
                        </PacingButton>

                    )
                )}
                {isTeacher && (
                    syllabusTeacher?.length > 0 && (
                        <PacingButton className='pacingItemMob' onClick={() => {
                            if (!syllabusTeacher || syllabusTeacher.length === 0) {
                                setPopupMessage('No Images were found in this book.')
                                setOpen(true);
                            }
                            else {
                                setSyllabusModal(true);
                                setPacingModal(false);
                            }
                        }}>
                            Syllabus
                        </PacingButton>
                    )
                    )}
                </MobileContainer>
                <RenderMenu menu={data?.structures} />
            </Drawer>
        </>
    </SentryWrap>
    );
};



function forceNoScroll() {
    if(window.innerWidth > 770){
  document.documentElement.classList.add('fullscreen-no-scroll');
  document.body.classList.add('fullscreen-no-scroll');
  document.documentElement.style.overflow = 'hidden';
  document.documentElement.style.overflowX = 'hidden';
  document.documentElement.style.overflowY = 'hidden';
  document.body.style.overflow = 'hidden';
  document.body.style.overflowX = 'hidden';
  document.body.style.overflowY = 'hidden';
    }
}

function removeNoScroll() {
  document.documentElement.classList.remove('fullscreen-no-scroll');
  document.body.classList.remove('fullscreen-no-scroll');
  document.documentElement.style.overflow = '';
  document.documentElement.style.overflowX = '';
  document.documentElement.style.overflowY = '';
  document.body.style.overflow = '';
  document.body.style.overflowX = '';
  document.body.style.overflowY = '';
}

export default EbookLayout;